
// Extrai tenant_id do JWT token - evita conflito entre tenants
function getTenantIdFromToken() {
  try {
    const token = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
    if (!token) return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1"; }
}

// Mesma logica de components/Layout.js: chave de cache de config isolada por tenant
function getConfigKey() {
  try {
    const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    if (!token) return "saas_config";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return "saas_config_tenant_" + (payload.tenant_id || "1");
  } catch { return "saas_config"; }
}

﻿import API_BASE from "../config.js";
import { Dica, BotaoDica } from "../components/Dica";
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import useTextosSegmento, { tSegDireto } from "../i18n/useTextosSegmento";
import i18n from "../i18n";
import { getLimitePlano, getPlanoAtual } from "../services/planLimits";
// AUD-M2 (19/10/2026): a mesma formatacao que Clientes.js, Agendamentos.js e
// o Modal de Orcamento ja usam. Nenhuma mascara nova foi escrita.
import { fmt } from "../services/formato";
import { authFetch } from "../services/authFetch";
import { totaisDoOrcamento, emReais } from "../services/precoPeca";
import { rolo } from "../styles/rolo";
import { adicionarNotificacao } from "../components/Header";
import Layout from "../components/Layout";
import Modal from "../components/Modal";
import PainelWhatsApp from "../components/PainelWhatsApp";

// Fase 2 do modulo de pagamentos -- aditivo, nao substitui nada existente
const STATUS_FIN_LABEL = {pendente:"Pendente",parcial:"Parcial",quitado:"Quitado",a_prazo:"A Prazo",vencido:"Vencido",cancelado:"Cancelado"};
const STATUS_FIN_COR = {pendente:"#64748b33",parcial:"#f59e0b33",quitado:"#22c55e33",a_prazo:"#3b82f633",vencido:"#ef444433",cancelado:"#64748b33"};

const STATUS_FLOW = ["Recepcao","Diagnostico","Aguardando Aprovacao","Aguardando Pecas","Em Servico","Concluido","Entregue"];
const STATUS_COR = {
  "Recepcao":             { bg:"#6366f122", cor:"#818cf8",  dot:"#6366f1" },
  "Diagnostico":          { bg:"#f59e0b22", cor:"#fbbf24",  dot:"#f59e0b" },
  "Aguardando Aprovacao": { bg:"#f9731622", cor:"#fb923c",  dot:"#f97316" },
  "Em Servico":           { bg:"#3b82f622", cor:"#60a5fa",  dot:"#3b82f6" },
  "Aguardando Pecas":     { bg:"#eab30822", cor:"#fde047",  dot:"#eab308" },
  "Concluido":            { bg:"#22c55e22", cor:"#4ade80",  dot:"#22c55e" },
  "Entregue":             { bg:"#94a3b822", cor:"#94a3b8",  dot:"#94a3b8" },
};

const SERVICOS_CATALOGO = [
  { nome:"Troca de oleo",             preco:89.90,  tipo:"Mao de Obra", categoria:"Lubrificacao" },
  { nome:"Troca de filtro de oleo",   preco:45.00,  tipo:"Mao de Obra", categoria:"Lubrificacao" },
  { nome:"Troca de filtro de ar",     preco:40.00,  tipo:"Mao de Obra", categoria:"Filtragem" },
  { nome:"Troca de filtro de cabine", preco:50.00,  tipo:"Mao de Obra", categoria:"Filtragem" },
  { nome:"Troca de filtro de combustivel", preco:60.00, tipo:"Mao de Obra", categoria:"Filtragem" },
  { nome:"Alinhamento",               preco:120.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Balanceamento",             preco:80.00,  tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Alinhamento e Balanceamento", preco:180.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de pastilha dianteira", preco:150.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Troca de pastilha traseira", preco:150.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Troca de disco de freio",   preco:200.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Sangria de freios",         preco:120.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Revisao de freios completa", preco:350.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Troca de correia dentada",  preco:380.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Troca de correia alternador", preco:120.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Troca de vela de ignicao",  preco:180.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Limpeza de bicos injetores", preco:250.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Troca de bomba d agua",     preco:300.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Troca de termostato",       preco:150.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Revisao completa",          preco:450.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Diagnostico motor",         preco:150.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Diagnostico eletrico",      preco:150.00, tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Troca de bateria",          preco:80.00,  tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Troca de alternador",       preco:250.00, tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Troca de motor de arranque", preco:250.00, tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Instalacao de som",         preco:150.00, tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Troca de amortecedor dianteiro", preco:300.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de amortecedor traseiro", preco:300.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de terminal de direcao", preco:150.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de barra estabilizadora", preco:200.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Geometria da direcao",      preco:200.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de embreagem",        preco:600.00, tipo:"Mao de Obra", categoria:"Transmissao" },
  { nome:"Troca de fluido de cambio", preco:150.00, tipo:"Mao de Obra", categoria:"Transmissao" },
  { nome:"Revisao de cambio",         preco:400.00, tipo:"Mao de Obra", categoria:"Transmissao" },
  { nome:"Troca de fluido de freio",  preco:80.00,  tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Troca de fluido de direcao", preco:80.00, tipo:"Mao de Obra", categoria:"Direcao" },
  { nome:"Limpeza de sistema de arrefecimento", preco:200.00, tipo:"Mao de Obra", categoria:"Arrefecimento" },
  { nome:"Troca de mangueiras de arrefecimento", preco:180.00, tipo:"Mao de Obra", categoria:"Arrefecimento" },
  { nome:"Revisao de ar condicionado", preco:300.00, tipo:"Mao de Obra", categoria:"Ar Condicionado" },
  { nome:"Recarga de gas do ar",      preco:200.00, tipo:"Mao de Obra", categoria:"Ar Condicionado" },
  { nome:"Higienizacao do ar condicionado", preco:150.00, tipo:"Mao de Obra", categoria:"Ar Condicionado" },
  { nome:"Oleo 5W-30 1L",            preco:28.90,  tipo:"Peca", categoria:"Lubrificacao" },
  { nome:"Oleo 5W-40 1L",            preco:32.90,  tipo:"Peca", categoria:"Lubrificacao" },
  { nome:"Oleo 10W-40 1L",           preco:24.90,  tipo:"Peca", categoria:"Lubrificacao" },
  { nome:"Filtro de oleo",            preco:35.00,  tipo:"Peca", categoria:"Filtragem" },
  { nome:"Filtro de ar",              preco:42.00,  tipo:"Peca", categoria:"Filtragem" },
  { nome:"Filtro de cabine",          preco:38.00,  tipo:"Peca", categoria:"Filtragem" },
  { nome:"Filtro de combustivel",     preco:45.00,  tipo:"Peca", categoria:"Filtragem" },
  { nome:"Pastilha de freio dianteira", preco:120.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Pastilha de freio traseira", preco:110.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Disco de freio dianteiro",  preco:180.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Disco de freio traseiro",   preco:160.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Fluido de freio DOT4",      preco:22.00,  tipo:"Peca", categoria:"Freios" },
  { nome:"Vela de ignicao",           preco:18.50,  tipo:"Peca", categoria:"Motor" },
  { nome:"Correia dentada",           preco:125.00, tipo:"Peca", categoria:"Motor" },
  { nome:"Correia alternador",        preco:45.00,  tipo:"Peca", categoria:"Motor" },
  { nome:"Bomba d agua",              preco:180.00, tipo:"Peca", categoria:"Motor" },
  { nome:"Termostato",                preco:65.00,  tipo:"Peca", categoria:"Motor" },
  { nome:"Amortecedor dianteiro",     preco:320.00, tipo:"Peca", categoria:"Suspensao" },
  { nome:"Amortecedor traseiro",      preco:280.00, tipo:"Peca", categoria:"Suspensao" },
  { nome:"Terminal de direcao",       preco:85.00,  tipo:"Peca", categoria:"Suspensao" },
  { nome:"Bateria 60Ah",              preco:380.00, tipo:"Peca", categoria:"Eletrica" },
  { nome:"Bateria 70Ah",              preco:450.00, tipo:"Peca", categoria:"Eletrica" },
];

// Correcao critica -- vazamento entre tenants: STORAGE_KEY era uma chave
// FIXA e global, entao salvarHistorico() (chamado a cada mudanca da lista
// de OS) gravava os dados completos da oficina atual (cliente, telefone,
// cpf, placa, veiculo, obs) numa chave que QUALQUER outra oficina aberta
// nesse navegador podia ler de volta via carregarHistorico() (usado como
// fallback quando a API falha e o cache tenant-scoped esta vazio). Agora
// a chave e isolada por tenant, igual o resto do sistema ja fazia.
function getHistoricoKey() { return "os_historico_tenant_" + (getTenantIdFromToken() || "1"); }
// Correcao critica -- vazamento entre tenants (mesmo padrao do os_historico):
// a lixeira guarda OS COMPLETAS (cliente, telefone, cpf, placa, veiculo, obs)
// e o historico de busca guarda o que foi digitado; ambos eram chaves FIXAS
// e globais, entao qualquer outra oficina aberta nesse navegador lia esses
// dados de volta. Agora sao isoladas por tenant, igual o resto do sistema.
function getBuscaHistKey() { return "os_busca_historico_tenant_" + (getTenantIdFromToken() || "1"); }
function getLixeiraKey() { return "os_lixeira_tenant_" + (getTenantIdFromToken() || "1"); }

function carregarHistBusca() {
  try { return JSON.parse(localStorage.getItem(getBuscaHistKey()) || "[]"); } catch { return []; }
}
function registrarBusca(item) {
  const hist = carregarHistBusca();
  const existe = hist.findIndex(h => h.nome === item.nome);
  if (existe >= 0) { hist[existe].usos = (hist[existe].usos || 1) + 1; hist[existe].ultimo = Date.now(); }
  else { hist.unshift({ ...item, usos: 1, ultimo: Date.now() }); }
  try { localStorage.setItem(getBuscaHistKey(), JSON.stringify(hist.slice(0, 30))); } catch (e) { console.warn("os_cache setItem failed (non-fatal):", e); }
}
function getServicosInteligentes(catalogoCompleto) {
  const hist = carregarHistBusca();
  if (hist.length === 0) return catalogoCompleto;
  const maisUsados = hist.sort((a,b) => (b.usos||0) - (a.usos||0)).slice(0, 8);
  const resto = catalogoCompleto.filter(s => !maisUsados.find(m => m.nome === s.nome));
  return [...maisUsados, ...resto];
}
function carregarLixeira() {
  try { return JSON.parse(localStorage.getItem(getLixeiraKey()) || "[]"); } catch { return []; }
}
function salvarLixeira(lista) {
  try { localStorage.setItem(getLixeiraKey(), JSON.stringify(lista)); } catch {}
}
function moverParaLixeira(os) {
  const lixeira = carregarLixeira();
  if (!lixeira.find(o => o.id === os.id)) {
    salvarLixeira([{ ...os, _removidoEm: Date.now() }, ...lixeira]);
  }
}
const DOZE_MESES = 365 * 24 * 60 * 60 * 1000;
function carregarHistorico() {
  try {
    const raw = localStorage.getItem(getHistoricoKey());
    if (!raw) return [];
    const dados = JSON.parse(raw);
    const corte = Date.now() - DOZE_MESES;
    return dados.filter(os => new Date(os._criadoEm || os.criada).getTime() > corte);
  } catch { return []; }
}
function salvarHistorico(lista) {
  try { localStorage.setItem(getHistoricoKey(), JSON.stringify(lista)); } catch {}
}
async function salvarOSAPI(tenantId, os) {
  try {
    const r = await authFetch("/api/v1/dados/os/" + tenantId, {
      method: "POST",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify(os)
    });
    if(r.ok) {
      const data = await r.json();
      return data.id || true;
    }
    return false;
  } catch(e) { return false; }
}
async function excluirOSAPI(tenantId, osId) {
  try {
    await authFetch("" + API_BASE + "/api/v1/dados/os/" + tenantId + "/" + osId, {
      method: "DELETE"
    });
  } catch {}
}

function exportarHTML(lista, nomeEmpresa) {
  // AUD-E: binder sensivel ao segmento. Cobre todas as chaves deste
  // exportador; as sem variante _moto seguem exatamente iguais.
  const t = (chave, ...resto) => tSegDireto(i18n, chave, ...resto);
  const STATUS_LABEL = (s) => t("os.status." + s, s);
  const totalGeral = lista.reduce((a, o) => a + (o.total || 0), 0);
  const porStatus = {};
  const porMes = {};
  lista.forEach(os => {
    porStatus[os.status] = (porStatus[os.status] || 0) + 1;
    const mes = os.criada ? os.criada.substring(3, 10) : "??";
    porMes[mes] = (porMes[mes] || 0) + (os.total || 0);
  });
  const cores = {
    "Recepcao":"#6366f1","Diagnostico":"#f59e0b","Aguardando Aprovacao":"#f97316",
    "Em Servico":"#3b82f6","Aguardando Pecas":"#eab308","Concluido":"#22c55e","Entregue":"#94a3b8"
  };
  const meses = Object.keys(porMes).sort();
  const maxMes = Math.max(...Object.values(porMes), 1);

  const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
<meta charset="UTF-8">
<title>${nomeEmpresa || "SAAS.GL"}</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0f172a; color: #f1f5f9; font-family: 'Segoe UI', Arial, sans-serif; padding: 32px; }
  h1 { font-size: 28px; font-weight: 800; color: #fff; }
  .sub { color: #64748b; font-size: 13px; margin-top: 4px; }
  .header { align-items: flex-start; border-bottom: 1px solid #1e293b; display: flex; justify-content: space-between; margin-bottom: 32px; padding-bottom: 24px; }
  .badge { background: linear-gradient(135deg,#6366f1,#3b82f6); border-radius: 8px; color: #fff; font-size: 12px; font-weight: 700; padding: 4px 14px; }
  .cards { display: grid; gap: 16px; grid-template-columns: repeat(4,1fr); margin-bottom: 32px; }
  .card { background: #131929; border: 1px solid #1e293b; border-radius: 12px; padding: 20px; }
  .card-label { color: #64748b; font-size: 11px; font-weight: 700; letter-spacing: 0.08em; margin-bottom: 8px; text-transform: uppercase; }
  .card-value { font-size: 26px; font-weight: 800; }
  .section { background: #131929; border: 1px solid #1e293b; border-radius: 12px; margin-bottom: 24px; padding: 24px; }
  .section-title { color: #94a3b8; font-size: 12px; font-weight: 700; letter-spacing: 0.08em; margin-bottom: 20px; text-transform: uppercase; }
  .chart-bar-row { align-items: center; display: flex; gap: 12px; margin-bottom: 12px; }
  .chart-label { color: #94a3b8; font-size: 12px; min-width: 80px; }
  .chart-bar-bg { background: #1e293b; border-radius: 99px; flex: 1; height: 10px; overflow: hidden; }
  .chart-bar-fill { border-radius: 99px; height: 10px; }
  .chart-count { color: #64748b; font-size: 11px; min-width: 30px; text-align: right; }
  table { border-collapse: collapse; width: 100%; }
  th { background: #1e293b; color: #64748b; font-size: 11px; font-weight: 700; letter-spacing: 0.06em; padding: 12px 14px; text-align: left; text-transform: uppercase; }
  td { border-top: 1px solid #1e293b; font-size: 13px; padding: 12px 14px; }
  .status-badge { border-radius: 20px; font-size: 11px; font-weight: 600; padding: 3px 10px; }
  .total-cell { color: #22c55e; font-weight: 700; }
  .footer { color: #334155; font-size: 11px; margin-top: 32px; text-align: center; }
</style>
</head>
<body>
<div class="header">
  <div><h1>${nomeEmpresa || "SAAS.GL"}</h1><div class="sub">${t("os.export.gerado_em")} ${new Date().toLocaleDateString("pt-BR")}</div></div>
  <div class="badge">${t("os.export.report_badge")}</div>
</div>
<div class="cards">
  <div class="card"><div class="card-label">${t("os.export.card_total_os")}</div><div class="card-value" style="color:#6366f1">${lista.length}</div></div>
  <div class="card"><div class="card-label">${t("os.export.card_faturamento_total")}</div><div class="card-value" style="color:#22c55e">R$ ${totalGeral.toLocaleString("pt-BR",{minimumFractionDigits:2})}</div></div>
  <div class="card"><div class="card-label">${t("os.export.card_os_concluidas")}</div><div class="card-value" style="color:#3b82f6">${lista.filter(o=>o.status==="Concluido"||o.status==="Entregue").length}</div></div>
  <div class="card"><div class="card-label">${t("os.export.card_em_aberto")}</div><div class="card-value" style="color:#f59e0b">${lista.filter(o=>o.status!=="Concluido"&&o.status!=="Entregue").length}</div></div>
</div>
<div style="display:grid;gap:24px;grid-template-columns:1fr 1fr;margin-bottom:24px">
  <div class="section">
    <div class="section-title">${t("os.export.dist_por_status")}</div>
    ${Object.entries(porStatus).map(([s,n])=>`<div class="chart-bar-row"><div class="chart-label">${STATUS_LABEL(s)}</div><div class="chart-bar-bg"><div class="chart-bar-fill" style="width:${Math.round(n/lista.length*100)}%;background:${cores[s]||"#6366f1"}"></div></div><div class="chart-count">${n}</div></div>`).join("")}
  </div>
  <div class="section">
    <div class="section-title">${t("os.export.fat_por_mes")}</div>
    ${meses.map(m=>`<div class="chart-bar-row"><div class="chart-label">${m}</div><div class="chart-bar-bg"><div class="chart-bar-fill" style="width:${Math.round(porMes[m]/maxMes*100)}%;background:linear-gradient(90deg,#6366f1,#3b82f6)"></div></div><div class="chart-count" style="min-width:80px;color:#22c55e">R$ ${porMes[m].toLocaleString("pt-BR",{minimumFractionDigits:2})}</div></div>`).join("")}
  </div>
</div>
<div class="section">
  <div class="section-title">${t("os.export.historico_completo", { count: lista.length })}</div>
  <table>
    <thead><tr><th>${t("os.col_os")}</th><th>${t("os.export.col_data")}</th><th>${t("os.col_cliente")}</th><th>${t("os.col_veiculo")}</th><th>${t("os.col_placa")}</th><th>${t("os.col_tecnico")}</th><th>${t("os.col_status")}</th><th>${t("os.col_total")}</th></tr></thead>
    <tbody>
      ${lista.map(os=>`<tr>
        <td style="font-family:monospace;font-weight:700;color:#818cf8">${os.id}</td>
        <td style="color:#64748b;font-size:11px">${os.criada}</td>
        <td><div style="font-weight:600">${os.cliente}</div>${os.telefone?`<div style="color:#64748b;font-size:11px">${os.telefone}</div>`:""}</td>
        <td><div>${os.veiculo}</div></td>
        <td style="font-family:monospace;font-weight:700">${os.placa}</td>
        <td style="color:#94a3b8">${os.tecnico||"-"}</td>
        <td><span class="status-badge" style="background:${cores[os.status]||"#6366f1"}22;color:${cores[os.status]||"#6366f1"}">${STATUS_LABEL(os.status)}</span></td>
        <td class="total-cell">${os.total>0?"R$ "+os.total.toLocaleString("pt-BR",{minimumFractionDigits:2}):"-"}</td>
      </tr>`).join("")}
    </tbody>
  </table>
</div>
<div class="footer">${t("os.export.footer_gerado_por")} SAAS.GL &bull; ${new Date().toLocaleString("pt-BR")}</div>
</body>
</html>`;

  const blob = new Blob([html], { type: "text/html;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "relatorio_os_" + new Date().toLocaleDateString("pt-BR").replace(/\//g,"-") + ".html";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// ---------------------------------------------------------------------------
// Qual e, de fato, a lista de itens de uma OS.
//
// Os itens do orcamento moram no JSON da coluna `orcamento`. A coluna
// `servicos` guarda a triagem da abertura da OS e fica vazia depois que a
// OS passa pelo orcamento (a rota que salva o orcamento nunca escreve
// nesse campo). Por isso a coluna SERVICOS, o detalhe e o CSV apareciam em
// branco mesmo com o orcamento cheio.
//
// Mesma regra que o abrirOrcamento ja aplica desde 01/09: vale o orcamento
// salvo quando ele tem itens; senao, vale a triagem. Leitura pura -- nao
// grava nada e nao altera o banco. OS com orcamento invalido caem no
// try/catch e seguem pelo caminho antigo.
function itensDaOS(os) {
  if (!os || typeof os !== "object") return [];
  try {
    const orc = JSON.parse(os.orcamento || "null");
    if (orc && Array.isArray(orc.itens) && orc.itens.length > 0) return orc.itens;
  } catch {}
  return Array.isArray(os.servicos) ? os.servicos : [];
}

function exportarCSV(lista) {
  // AUD-E: binder sensivel ao segmento. Cobre todas as chaves deste
  // exportador; as sem variante _moto seguem exatamente iguais.
  const t = (chave, ...resto) => tSegDireto(i18n, chave, ...resto);
  const STATUS_LABEL = (s) => t("os.status." + s, s);
  const sep = ";";
  const header = [t("os.export.col_numero_os"),t("os.export.col_data"),t("os.col_cliente"),t("os.detalhe.telefone"),t("os.nova.cpf_cnpj"),t("os.col_veiculo"),t("os.col_placa"),t("os.detalhe.km"),t("os.col_tecnico"),t("os.col_status"),t("os.export.col_servicos_realizados"),t("os.export.col_total_reais"),t("os.detalhe.relato_cliente"),t("os.detalhe.obs_tecnicas")];
  const rows = lista.map(os => [
    os.id, os.criada, os.cliente, os.telefone||"", os.cpf||"", os.veiculo, os.placa, os.km||"", os.tecnico||"", STATUS_LABEL(os.status),
    itensDaOS(os).map(s=>s.nome+" (R$ "+Number(s.preco).toFixed(2).replace(".",",")+")").join(" | "),
    "R$ "+(os.total||0).toFixed(2).replace(".",","), os.relatoCliente||"", os.obs||""
  ]);
  const linhas = [header,...rows].map(r=>r.map(c=>'"'+String(c).replace(/"/g,'""')+'"').join(sep));
  const blob = new Blob(["\uFEFF"+linhas.join("\r\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "historico_os_"+new Date().toLocaleDateString("pt-BR").replace(/\//g,"-")+".csv";
  document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
}

function BtnFechar({ onClick }) {
  return <button onClick={onClick} style={{background:"var(--bg4)",border:"none",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:20,lineHeight:1,padding:"4px 10px"}}>x</button>;
}

function CardKanban({ os, onClick }) {
  const cor = STATUS_COR[os.status] || STATUS_COR["Recepcao"];
  return (
    <div onClick={onClick} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,cursor:"pointer",marginBottom:8,padding:12}}
      onMouseOver={e=>e.currentTarget.style.borderColor=cor.dot}
      onMouseOut={e=>e.currentTarget.style.borderColor="var(--border)"}>
      <div style={{color:"var(--accent2)",fontFamily:"monospace",fontSize:11,marginBottom:4}}>{os.id}</div>
      <div style={{fontSize:13,fontWeight:600,marginBottom:2}}>{os.cliente}</div>
      <div style={{color:"var(--text2)",fontSize:11,marginBottom:6}}>{os.veiculo}</div>
      <div style={{alignItems:"center",display:"flex",justifyContent:"space-between"}}>
        <span style={{background:"var(--bg4)",borderRadius:4,fontFamily:"monospace",fontSize:11,fontWeight:700,padding:"2px 6px"}}>{os.placa}</span>
        {os.total > 0 && <span style={{color:"var(--green)",fontSize:12,fontWeight:600}}>R$ {os.total.toFixed(2)}</span>}
      </div>
    </div>
  );
}

export default function OS() {
  const { t } = useTranslation();
  // AUD-E: t() sensivel ao segmento. Usado SO nas chamadas de
  // vocabulario de veiculo; o resto da tela segue no t() de sempre.
  const { tSeg } = useTextosSegmento();
  const STATUS_LABEL = (s) => t("os.status." + s, s);
  const fetchGen = useRef(0);
  const [lista, setLista] = useState([]);
  const [_featuresBackend, setFeaturesBackend] = useState(()=>{try{const tid=getTenantIdFromToken()||"1";return JSON.parse(localStorage.getItem("dev_features_liberadas_tenant_"+tid)||"[]");}catch{return[];}});
  useEffect(()=>{const tid=getTenantIdFromToken()||"1";authFetch(API_BASE+"/api/v1/config/features_liberadas_tenant_"+tid).then(r=>r.ok?r.json():null).then(d=>{if(d&&d.value&&d.value.features){setFeaturesBackend(d.value.features);try{localStorage.setItem("dev_features_liberadas_tenant_"+tid,JSON.stringify(d.value.features));}catch(e){}}}).catch(()=>{});},[]);
  const [filtroStatus, setFiltroStatus] = useState("Todos");
  const [busca, setBusca] = useState("");
  const [tab, setTab] = useState("lista");
  const [expandida, setExpandida] = useState(null);
  const [modalNova, setModalNova] = useState(() => { try { return !!localStorage.getItem("os_prefill"); } catch { return false; } });
  const [modalDetalhe, setModalDetalhe] = useState(null);
  const [modalConcluir, setModalConcluir] = useState(null);
  // Restauracao em curso (id da O.S.) e o recado do servidor quando ela
  // e recusada. Antes nao havia nem uma coisa nem outra: o botao dizia
  // que restaurou sem nunca ter falado com o servidor.
  const [restaurando, setRestaurando] = useState(null);
  const [erroRestaurar, setErroRestaurar] = useState("");
  const [modalOrcamento, setModalOrcamento] = useState(null);
  // AUD-G (24/09/2026) -- o dono editava, via o total mudar, fechava e perdia,
  // sem nenhum aviso. E quando o servidor recusava a gravacao a tela avancava
  // assim mesmo, porque a resposta nao era olhada.
  //
  // A tela descobre sozinha se ha pendencia comparando uma ASSINATURA do que
  // esta na tela com a do ultimo salvamento aceito. Fiz assim, e nao marcando
  // "sujo" em cada funcao de edicao, por dois motivos: pega qualquer alteracao,
  // inclusive as que eu deixaria passar (data/hora e fotos entram junto), e
  // desfazer a mao volta a ficar limpo, que e o que a pessoa espera.
  //
  // `modeloOrc` fica de FORA da assinatura de proposito: ele nao e recarregado
  // do orcamento salvo ao reabrir, entao compara-lo acusaria pendencia falsa
  // toda vez que o modal abrisse.
  const [orcBase, setOrcBase] = useState("");
  const [orcAviso, setOrcAviso] = useState(null);
  const [orcSalvando, setOrcSalvando] = useState(false);
  const [confirmandoFecharOrc, setConfirmandoFecharOrc] = useState(false);
  const assinaturaOrc = (itens, dataHora, fotos) => {
    try { return JSON.stringify({ itens: itens || [], dataHora: dataHora || "", fotos: fotos || [] }); }
    catch (e) { return ""; }
  };
  const [modeloOrc, setModeloOrc] = useState(() => { const p = ((sessionStorage.getItem("plano")||localStorage.getItem("plano"))||"basico").toLowerCase(); return p==="premium"?p:"basico"; });
  const [fotasPremium, setFotasPremium] = useState([]); // [{url, descricao}]
  // AUD-G: ha pendencia quando o que esta na tela nao bate com o ultimo
  // salvamento que o servidor aceitou.
  const orcSujo = !!modalOrcamento &&
    assinaturaOrc(modalOrcamento.itens, modalOrcamento.dataHora, fotasPremium) !== orcBase;
  const [painelFotos, setPainelFotos] = useState(false);
  const [obsOrcamento, setObsOrcamento] = useState("");
  const [orcCfg, setOrcCfg] = useState(null);
  // Fase 2 -- origem da peca: itens reais do Estoque, carregados ao abrir o
  // orcamento. Aditivo -- nao substitui o Catalogo de Servicos existente.
  const [estoqueItens, setEstoqueItens] = useState([]);
  const [formFornecedor, setFormFornecedor] = useState({ nome:"", fornecedor:"", custo:"", preco:"", qtd:"1" });
  const [msgLimpeza, setMsgLimpeza] = useState("");
  const [modalImpressao, setModalImpressao] = useState(false);
  const [modalLixeira, setModalLixeira] = useState(false);
  const [lixeira, setLixeira] = useState([]);
  const [modalStatus, setModalStatus] = useState(null);
  const [modalPagamento, setModalPagamento] = useState(null);
  const [pagamentosData, setPagamentosData] = useState(null);
  const [carregandoPagamentos, setCarregandoPagamentos] = useState(false);
  const [formPagamento, setFormPagamento] = useState({valor:"",forma:"pix",observacao:""});
  const [enviandoPagamento, setEnviandoPagamento] = useState(false);
  const [erroPagamento, setErroPagamento] = useState("");
  const [estornandoId, setEstornandoId] = useState(null);
  const [motivoEstorno, setMotivoEstorno] = useState("");
  const [glowSucesso, setGlowSucesso] = useState(false);
  const [modalAcordo, setModalAcordo] = useState(null);
  const [acordoData, setAcordoData] = useState(null);
  const [carregandoAcordo, setCarregandoAcordo] = useState(false);
  const [erroAcordo, setErroAcordo] = useState("");
  const [modoAcordo, setModoAcordo] = useState("automatico");
  const [tipoAcordoNovo, setTipoAcordoNovo] = useState("promissoria");
  const [formAcordoAuto, setFormAcordoAuto] = useState({valorTotal:"",numeroParcelas:"3",dataInicio:new Date().toISOString().slice(0,10),intervaloTipo:"mensal",intervaloDias:"30"});
  const [parcelasAcordo, setParcelasAcordo] = useState([]);
  const [enviandoAcordo, setEnviandoAcordo] = useState(false);
  const [pagandoParcelaId, setPagandoParcelaId] = useState(null);
  const [formaPagParcela, setFormaPagParcela] = useState("pix");
  const [cancelandoAcordo, setCancelandoAcordo] = useState(false);
  const [motivoCancelAcordo, setMotivoCancelAcordo] = useState("");
  // status, estoque nem nenhum fluxo existente.
  const fecharPagamentos = () => {
    setModalPagamento(null);
    setPagamentosData(null);
    setFormPagamento({valor:"",forma:"pix",observacao:""});
    setErroPagamento("");
    setEstornandoId(null);
    setMotivoEstorno("");
  };
  const abrirPagamentos = (os) => {
    setModalPagamento(os);
    setPagamentosData(null);
    setCarregandoPagamentos(true);
    setErroPagamento("");
    setEstornandoId(null);
    setMotivoEstorno("");
    authFetch(""+API_BASE+"/api/v1/pagamentos/"+tenantIdGlobal+"/os/"+os.id)
      .then(r=>r.ok?r.json():Promise.reject())
      .then(d=>{setPagamentosData(d);setCarregandoPagamentos(false);})
      .catch(()=>{setPagamentosData(null);setCarregandoPagamentos(false);setErroPagamento("Nao foi possivel carregar os pagamentos.");});
    // O acordo a prazo vem em paralelo: e dele que saem "A receber" e
    // "Vencido". Se falhar, o resto da tela continua funcionando igual --
    // a O.S. sem acordo e o caso mais comum.
    setModalAcordo(null); setErroAcordo(""); setParcelasAcordo([]);
    setCarregandoAcordo(true);
    authFetch(""+API_BASE+"/api/v1/pagamentos/"+tenantIdGlobal+"/os/"+os.id+"/acordo")
      .then(r=>r.ok?r.json():Promise.reject())
      .then(d=>{setAcordoData(d);setCarregandoAcordo(false);})
      .catch(()=>{setAcordoData(null);setCarregandoAcordo(false);});
  };
  const registrarNovoPagamento = () => {
    if (!modalPagamento) return;
    const valorNum = parseFloat(formPagamento.valor);
    if (!valorNum || valorNum<=0) { setErroPagamento("Informe um valor valido."); return; }
    setEnviandoPagamento(true);
    setErroPagamento("");
    authFetch(""+API_BASE+"/api/v1/pagamentos/"+tenantIdGlobal+"/os/"+modalPagamento.id, {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({valor:valorNum, formaPagamento:formPagamento.forma, observacao:formPagamento.observacao}),
    }).then(async r=>{
      if(!r.ok){ const err=await r.json().catch(()=>({})); throw new Error(err.detail||"Erro ao registrar pagamento"); }
      return r.json();
    }).then(()=>{
      setFormPagamento({valor:"",forma:"pix",observacao:""});
      setEnviandoPagamento(false);
      abrirPagamentos(modalPagamento);
      setGlowSucesso(true);
      setTimeout(()=>setGlowSucesso(false), 1700);
    }).catch(e=>{
      setErroPagamento(e.message||"Erro ao registrar pagamento");
      setEnviandoPagamento(false);
    });
  };
  // ── Acordo a prazo / promissoria ────────────────────────────────────
  // Soma das parcelas que ainda nao foram recebidas. "Vencido" e o
  // subconjunto cujo vencimento ja passou. Comparacao de datas ISO como
  // texto funciona porque o formato e AAAA-MM-DD.
  const resumoAcordo = () => {
    const ac = acordoData && acordoData.acordo;
    const ps = (ac && ac.status === "ativo" && acordoData.parcelas) || [];
    const hoje = new Date().toISOString().slice(0,10);
    let aReceber = 0, vencido = 0;
    ps.forEach(p => {
      if (p.situacao !== "pendente") return;
      const v = Number(p.valor) || 0;
      aReceber += v;
      if (String(p.data_vencimento||"").slice(0,10) < hoje) vencido += v;
    });
    return { aReceber: Math.round(aReceber*100)/100, vencido: Math.round(vencido*100)/100 };
  };

  // Previa: o servidor calcula as datas e distribui os centavos da ultima
  // parcela. NADA e gravado aqui -- e so simulacao.
  const gerarPreviaAcordo = () => {
    if (!modalPagamento) return;
    const valorNum = parseFloat(formAcordoAuto.valorTotal);
    if (!valorNum || valorNum<=0) { setErroAcordo("Informe o valor da promissoria."); return; }
    if (!formAcordoAuto.dataInicio) { setErroAcordo("Informe a data do primeiro vencimento."); return; }
    setEnviandoAcordo(true); setErroAcordo("");
    authFetch(""+API_BASE+"/api/v1/pagamentos/"+tenantIdGlobal+"/os/"+modalPagamento.id+"/acordo/preview", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({
        valorTotal: valorNum,
        numeroParcelas: parseInt(formAcordoAuto.numeroParcelas,10)||1,
        intervaloTipo: formAcordoAuto.intervaloTipo,
        intervaloDias: formAcordoAuto.intervaloTipo==="personalizado" ? (parseInt(formAcordoAuto.intervaloDias,10)||30) : null,
        dataInicio: formAcordoAuto.dataInicio,
      }),
    }).then(async r=>{
      if(!r.ok){ const err=await r.json().catch(()=>({})); throw new Error(err.detail||"Nao foi possivel calcular as parcelas"); }
      return r.json();
    }).then(d=>{
      setParcelasAcordo(d.parcelas||[]);
      setEnviandoAcordo(false);
    }).catch(e=>{
      setErroAcordo(e.message||"Nao foi possivel calcular as parcelas");
      setParcelasAcordo([]);
      setEnviandoAcordo(false);
    });
  };

  // Aqui o titulo passa a existir. Continua NAO entrando no caixa: o
  // backend so grava os_acordos_pagamento + os_acordo_parcelas.
  const confirmarAcordo = () => {
    if (!modalPagamento || parcelasAcordo.length===0) return;
    setEnviandoAcordo(true); setErroAcordo("");
    authFetch(""+API_BASE+"/api/v1/pagamentos/"+tenantIdGlobal+"/os/"+modalPagamento.id+"/acordo/confirmar", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({
        tipoAcordo: tipoAcordoNovo,
        intervaloTipo: formAcordoAuto.intervaloTipo,
        intervaloDias: formAcordoAuto.intervaloTipo==="personalizado" ? (parseInt(formAcordoAuto.intervaloDias,10)||30) : null,
        parcelas: parcelasAcordo,
      }),
    }).then(async r=>{
      if(!r.ok){ const err=await r.json().catch(()=>({})); throw new Error(err.detail||"Nao foi possivel registrar a promissoria"); }
      return r.json();
    }).then(()=>{
      setParcelasAcordo([]); setModalAcordo(null); setEnviandoAcordo(false);
      setFormPagamento(f=>({...f, forma:"pix", valor:""}));
      abrirPagamentos(modalPagamento);
      setGlowSucesso(true);
      setTimeout(()=>setGlowSucesso(false), 1700);
    }).catch(e=>{
      setErroAcordo(e.message||"Nao foi possivel registrar a promissoria");
      setEnviandoAcordo(false);
    });
  };

  // A baixa: E AQUI que o dinheiro entra. O backend insere em os_pagamentos,
  // espelha no financeiro como receita e marca a parcela como paga.
  const receberParcela = (parcelaId) => {
    setEnviandoAcordo(true); setErroAcordo("");
    authFetch(""+API_BASE+"/api/v1/pagamentos/"+tenantIdGlobal+"/parcela/"+parcelaId+"/pagar", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({formaPagamento: formaPagParcela}),
    }).then(async r=>{
      if(!r.ok){ const err=await r.json().catch(()=>({})); throw new Error(err.detail||"Nao foi possivel dar baixa na parcela"); }
      return r.json();
    }).then(()=>{
      setPagandoParcelaId(null); setEnviandoAcordo(false);
      abrirPagamentos(modalPagamento);
      setGlowSucesso(true);
      setTimeout(()=>setGlowSucesso(false), 1700);
    }).catch(e=>{
      setErroAcordo(e.message||"Nao foi possivel dar baixa na parcela");
      setEnviandoAcordo(false);
    });
  };

  // Cancelar nao apaga: marca o acordo como cancelado com motivo, e as
  // parcelas pendentes como canceladas. As ja pagas ficam como estao.
  const cancelarAcordo = (acordoId) => {
    if (!motivoCancelAcordo.trim()) { setErroAcordo("Informe o motivo do cancelamento."); return; }
    setEnviandoAcordo(true); setErroAcordo("");
    authFetch(""+API_BASE+"/api/v1/pagamentos/"+tenantIdGlobal+"/acordo/"+acordoId+"/cancelar", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({motivo: motivoCancelAcordo}),
    }).then(async r=>{
      if(!r.ok){ const err=await r.json().catch(()=>({})); throw new Error(err.detail||"Nao foi possivel cancelar o acordo"); }
      return r.json();
    }).then(()=>{
      setCancelandoAcordo(false); setMotivoCancelAcordo(""); setEnviandoAcordo(false);
      abrirPagamentos(modalPagamento);
    }).catch(e=>{
      setErroAcordo(e.message||"Nao foi possivel cancelar o acordo");
      setEnviandoAcordo(false);
    });
  };

  const confirmarEstorno = (pagamentoId) => {
    if (!motivoEstorno.trim()) { setErroPagamento("Informe o motivo do estorno."); return; }
    authFetch(""+API_BASE+"/api/v1/pagamentos/"+tenantIdGlobal+"/"+pagamentoId+"/estornar", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({motivo:motivoEstorno}),
    }).then(async r=>{
      if(!r.ok){ const err=await r.json().catch(()=>({})); throw new Error(err.detail||"Erro ao estornar"); }
      return r.json();
    }).then(()=>{
      setEstornandoId(null);
      setMotivoEstorno("");
      abrirPagamentos(modalPagamento);
      setGlowSucesso(true);
      setTimeout(()=>setGlowSucesso(false), 1700);
    }).catch(e=>{
      setErroPagamento(e.message||"Erro ao estornar");
    });
  };
  // Edicao de cadastro de uma OS ja existente (cliente/veiculo/placa/km/obs)
  // -- pedido do Abima de 31/08/2026, pra corrigir erro de digitacao sem
  // precisar excluir e recriar a OS do zero. Ver rota PATCH /os/{tid}/{id}
  // em services/tenant-service/src/routes/dados.py.
  const [editandoOS, setEditandoOS] = useState(false);
  const [formEditOS, setFormEditOS] = useState(null);
  const [salvandoEdicaoOS, setSalvandoEdicaoOS] = useState(false);
  const [mostrarHistoricoOS, setMostrarHistoricoOS] = useState(false);
  const [historicoOS, setHistoricoOS] = useState([]);
  const [carregandoHistoricoOS, setCarregandoHistoricoOS] = useState(false);
  const planoAtual = ((sessionStorage.getItem("plano")||localStorage.getItem("plano"))||"basico").toLowerCase();
  const _featuresLiberadas = _featuresBackend;
  const temRelatorioFree = planoAtual === "premium" || _featuresLiberadas.includes("relatorio_html");
  // AUD-M1 (18/10/2026) -- os limites REAIS das colunas de ordens_servico,
  // lidos de information_schema em 15/10. Nao sao numeros escolhidos: sao os
  // mesmos que o Postgres usa para recusar a gravacao.
  //
  // Sem isto, digitar 27 caracteres no KM devolvia 500 do servidor e a tela
  // mandava a oficina "fazer login de novo" -- aconteceu em producao.
  //
  // obs e relatoCliente NAO entram aqui: as colunas sao TEXT, sem limite. As
  // <textarea> continuam livres, como devem.
  const _LIMITE_CAMPO = { cliente:255, telefone:50, cpf:50, placa:20, veiculo:255, km:20, tecnico:255 };
  const formVazio = { cliente:"", telefone:"", cpf:"", placa:"", veiculo:"", km:"", tecnico:"", obs:"", relatoCliente:"", servicosSolicitados:[] };
  const [form, setForm] = useState(() => {
    try { const p = localStorage.getItem("os_prefill"); if (p) { localStorage.removeItem("os_prefill"); return { ...formVazio, ...JSON.parse(p) }; } } catch {}
    return formVazio;
  });
  const config = JSON.parse(localStorage.getItem(getConfigKey()) || "{}");
  const tenantIdGlobal = getTenantIdFromToken() || "1";

  // Comprovante de servico concluido: SOMENTE nome, quantidade e PRECO FINAL
  // de cada item. itensDaOS() devolve o item como ele foi gravado, e ele pode
  // carregar custoUnit/margem -- este map e a segunda barreira (a primeira
  // esta nos moldes de services/mensagens.js) para que custo e lucro nunca
  // alcancem o texto que o cliente le.
  const payloadComprovante = (os) => ({
    clienteNome: os.cliente,
    telefone: os.telefone,
    veiculo: os.veiculo,
    placa: os.placa,
    osNumero: os.id,
    itens: itensDaOS(os).map((i) => ({ nome: i.nome, qtd: i.qtd, preco: i.preco })),
    total: Number(os.total) || 0
  });

  useEffect(() => {
    setLixeira(carregarLixeira());
    const tenantId = getTenantIdFromToken() || "1";
    const OS_CACHE = "os_cache_tenant_"+tenantId;
    const gen = ++fetchGen.current;
    try { const cache = JSON.parse(localStorage.getItem(OS_CACHE)||"[]"); if(cache.length>0) { if(gen===fetchGen.current) setLista(cache); } } catch{}
    authFetch("/api/v1/dados/os/" + tenantId, {})
      .then(r => { if (!r.ok) throw new Error("os fetch failed: " + r.status); return r.json(); })
      .then(d => {
        if (Array.isArray(d) && gen === fetchGen.current) {
          setLista(d);
          salvarHistorico(d);
          try { localStorage.setItem(OS_CACHE, JSON.stringify(d)); } catch (e) { console.warn("os_cache setItem failed (non-fatal):", e); }
        }
      })
      .catch(() => {
        if (gen !== fetchGen.current) return;
        try { const cache = JSON.parse(localStorage.getItem(OS_CACHE)||"[]"); if(cache.length>0){setLista(cache);return;} } catch{}
        const hist = carregarHistorico();
        setLista(hist.length > 0 ? hist : []);
      });
    try {
      const cfg2 = JSON.parse(localStorage.getItem(getConfigKey()) || "{}");
      const plano = ((sessionStorage.getItem("plano")||localStorage.getItem("plano")) || cfg2.plano || "basico").toLowerCase();
      const tId = getTenantIdFromToken() || cfg2.tenant_id || "1";
      authFetch("" + API_BASE + "/api/v1/config/orcamento_config_tenant_" + tId + "?t=" + Date.now())
        .then(r => r.ok ? r.json() : null)
        .then(d => {
          if (d && d.value) {
            const dados = { ...d.value };
            
            
            dados._plano = plano;
            setOrcCfg(dados);
          }
        }).catch(() => {});
    } catch {}
  }, []);

  useEffect(() => { if (lista.length > 0) salvarHistorico(lista); }, [lista]);

  const upd = (campo, val) => setForm(f => ({ ...f, [campo]: val }));

  const toggleServico = (nome, preco, tipo, categoria) => setForm(f => {
    const existe = f.servicosSolicitados.find(s => s.nome === nome);
    if (!existe) registrarBusca({ nome, preco, tipo, categoria });
    return { ...f, servicosSolicitados: existe ? f.servicosSolicitados.filter(s => s.nome !== nome) : [...f.servicosSolicitados, { nome, preco, tipo, categoria }] };
  });

  const criarOS = async () => {
    if (!form.cliente || !form.placa || !form.veiculo) return;
    const _plano = getPlanoAtual();
    const _limites = getLimitePlano(_plano);
    const _osDoMes = lista.filter(o => { try { const d = new Date(o._criadoEm); const n = new Date(); return d.getMonth()===n.getMonth()&&d.getFullYear()===n.getFullYear(); } catch{return false;} }).length;
    if (_osDoMes >= _limites.max_os) { alert(t("os.alertas.limite_os", { max: _limites.max_os, plano: _plano.charAt(0).toUpperCase() + _plano.slice(1) })); return; }
    const _tid = getTenantIdFromToken()||"1";
    const payload = {
      cliente_id:form.cliente_id||null,
      cliente:form.cliente, telefone:form.telefone, cpf:form.cpf,
      placa:form.placa.toUpperCase(), veiculo:form.veiculo, km:form.km,
      status:"Recepcao", servicos:form.servicosSolicitados,
      total:form.servicosSolicitados.reduce((a,s)=>a+s.preco,0),
      tecnico:form.tecnico||"A definir",
      criada:new Date().toLocaleString("pt-BR"),
      obs:form.obs, relatoCliente:form.relatoCliente, _criadoEm:Date.now(),
    };
    try {
      // Salvar no banco - backend gera o ID
      const r = await authFetch("/api/v1/dados/os/"+_tid, {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify(payload)
      });
      if(r.ok){
        const data = await r.json();
        const osId = data.id;
        fetchGen.current++;
        const novaOS = { ...payload, id: osId, arquivado: false };
        setLista(l => {
          const atualizada = [novaOS, ...l];
          salvarHistorico(atualizada);
          try { localStorage.setItem("os_cache_tenant_"+_tid, JSON.stringify(atualizada)); } catch (e) { console.warn("os_cache setItem failed (non-fatal):", e); }
          return atualizada;
        });
        authFetch("/api/v1/dados/os/"+_tid, {}).then(r2 => r2.ok ? r2.json() : null).then(lista2 => {
          if (Array.isArray(lista2)) {
            setLista(lista2);
            salvarHistorico(lista2);
            try { localStorage.setItem("os_cache_tenant_"+_tid, JSON.stringify(lista2)); } catch (e) { console.warn("os_cache setItem failed (non-fatal):", e); }
          }
        }).catch(()=>{});
        adicionarNotificacao("nova_os", "Nova OS criada", osId + " - " + payload.cliente, osId);
        setForm(formVazio);
        setModalNova(false);
      } else {
        let detalhe = "";
        try { const erroData = await r.json(); detalhe = erroData.detail || erroData.message || JSON.stringify(erroData); } catch { detalhe = await r.text().catch(()=>""); }
        alert(t("os.alertas.erro_criar_prefix", { codigo: r.status }) + " " + (detalhe || t("os.alertas.tente_novamente")) + " " + t("os.alertas.dados_preservados"));
      }
    } catch(e) {
      alert(t("os.alertas.falha_conexao_prefix", { erro: e.message || e }) + " " + t("os.alertas.dados_preservados"));
    }
  };

  const moverStatus = (id, novoStatus) => {
    if (novoStatus === "Concluido") { setModalStatus(null); setModalConcluir(lista.find(o=>o.id===id)); return; }
    const nova = lista.map(o => o.id === id ? { ...o, status: novoStatus } : o);
    setLista(nova); salvarHistorico(nova);
    authFetch(""+API_BASE+"/api/v1/dados/os/"+tenantIdGlobal+"/"+id+"/status", {
      method: "PATCH",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify({status: novoStatus})
    }).then(()=>{
      try { localStorage.setItem("os_cache_tenant_"+tenantIdGlobal, JSON.stringify(nova)); } catch (e) { console.warn("os_cache setItem failed (non-fatal):", e); }
    }).catch(()=>{});
    // Refino de fluidez: apos confirmar o avanco de status, fecha os modais
    // (detalhe + selecao de status) em vez de reabrir o detalhe.
    if (modalDetalhe?.id === id) setModalDetalhe(null);
    setModalStatus(null);
  };

  const confirmarConclusao = () => {
    if (!modalConcluir) return;
    const id = modalConcluir.id;
    const nova = lista.map(o => o.id === id ? { ...o, status:"Concluido" } : o);
    setLista(nova); salvarHistorico(nova);
    // Fase 4 (02/09/2026, pedido do Abima) -- e aqui, na conclusao real do
    // servico, que a peca "sai da prateleira" de fato. Se o orcamento foi
    // confirmado mas o cliente desistiu antes de chegar aqui, o estoque
    // nunca e tocado. Mesma logica idempotente de antes (estoqueBaixado),
    // lida a partir do orcamento ja salvo na OS (o modal de orcamento pode
    // nem estar aberto neste momento).
    // Fase 4.1 (04/09/2026) -- a checagem de idempotencia (estoqueBaixado)
    // precisa ler o orcamento direto do backend, nao do estado local
    // (modalConcluir/lista podem estar desatualizados se a OS foi reaberta
    // e concluida de novo na mesma sessao, sem reload da pagina -- bug real
    // encontrado em teste funcional: causava baixa duplicada de estoque).
    authFetch(""+API_BASE+"/api/v1/dados/os/"+tenantIdGlobal)
      .then(r => r.ok ? r.json() : [])
      .then(lista2 => {
        const osAtual = Array.isArray(lista2) ? lista2.find(o => o.id === id) : null;
        let orcObj = null;
        try { orcObj = JSON.parse((osAtual && osAtual.orcamento) || modalConcluir.orcamento || "null"); } catch {}
        const jaBaixado = !!(orcObj && orcObj.estoqueBaixado);
        const itensParaBaixar = (!jaBaixado && orcObj)
          ? (orcObj.itens || []).filter(i => i.origem === "estoque_interno" && i.estoqueId)
          : [];
        itensParaBaixar.forEach(i => {
          authFetch(`${API_BASE}/api/v1/dados/estoque/${tenantIdGlobal}/${i.estoqueId}/ajustar`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ delta: -(Number(i.qtd) || 1), motivo: "OS concluida " + id, os_id: id, origem: "estoque_interno" }),
          }).catch(() => {});
        });
        if (orcObj && itensParaBaixar.length > 0) {
          authFetch(`${API_BASE}/api/v1/dados/os/${tenantIdGlobal}/${id}/orcamento`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ orcamento: JSON.stringify({ ...orcObj, estoqueBaixado: true }), orcamento_modelo: orcObj.modelo || "basico", total: orcObj.total || modalConcluir.total }),
          }).catch(() => {});
        }
      })
      .catch(() => {});
    authFetch(""+API_BASE+"/api/v1/dados/os/"+tenantIdGlobal+"/"+id+"/status", {
      method: "PATCH",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify({status: "Concluido"})
    }).then(()=>{
      try { localStorage.setItem("os_cache_tenant_"+tenantIdGlobal, JSON.stringify(nova)); } catch (e) { console.warn("os_cache setItem failed (non-fatal):", e); }
    }).catch(()=>{});
    setModalConcluir(null);
    setModalDetalhe(null);
  };

  // Restaura de verdade: pede ao servidor que reinsira a linha preservada
  // com o MESMO numero. So mexe na lixeira local depois do "ok" dele.
  //
  // O servidor recusa quando o numero ja foi reaproveitado por outra O.S.
  // (foi o que aconteceu com a OS-0008) ou quando a O.S. foi excluida antes
  // de 14/09/2026, quando a preservacao passou a existir. Nos dois casos a
  // O.S. CONTINUA na lixeira e a mensagem dele aparece na tela -- some da
  // lixeira sem ter voltado ao banco seria repetir o erro antigo.
  const restaurarOS = async (os) => {
    if (restaurando) return;
    setRestaurando(os.id);
    setErroRestaurar("");
    try {
      const r = await authFetch(
        API_BASE + "/api/v1/dados/registros-excluidos/" + tenantIdGlobal + "/os/" + os.id + "/restaurar",
        { method: "POST", headers: { "Content-Type": "application/json" }, body: "{}" }
      );
      const corpo = await r.json().catch(() => ({}));
      if (!r.ok) {
        setErroRestaurar(corpo.detail || t("os.lixeira_modal.erro_restaurar", "Nao foi possivel restaurar esta O.S."));
        setRestaurando(null);
        return;
      }
      const novaLix = lixeira.filter(o => o.id !== os.id);
      salvarLixeira(novaLix); setLixeira(novaLix);
      setRestaurando(null);
      // A lista vem do servidor, nao do que estava na tela: e a prova de que
      // a O.S. voltou mesmo ao banco.
      fetchGen.current++;
      carregar();
    } catch (e) {
      setErroRestaurar(t("os.lixeira_modal.erro_rede", "Sem resposta do servidor. A O.S. continua na lixeira."));
      setRestaurando(null);
    }
  };

  const excluirOS = (id) => {
    if (!window.confirm(t("os.alertas.mover_lixeira_confirm"))) return;
    const os = lista.find(o => o.id === id);
    if (os) { moverParaLixeira(os); setLixeira(carregarLixeira()); }
    const nova = lista.filter(o => o.id !== id);
    setLista(nova); salvarHistorico(nova); setModalDetalhe(null);
    excluirOSAPI(tenantIdGlobal, id);
  };

  const iniciarEdicaoOS = (os) => {
    setFormEditOS({
      cliente: os.cliente || "", telefone: os.telefone || "", cpf: os.cpf || "",
      placa: os.placa || "", veiculo: os.veiculo || "", km: os.km || "", obs: os.obs || "",
      // AUD-T1: sem esta linha o campo abriria vazio e o PATCH apagaria o
      // tecnico de quem so quis corrigir a placa.
      tecnico: os.tecnico || "",
      relatoCliente: os.relatoCliente || "",
    });
    setEditandoOS(true);
  };

  const cancelarEdicaoOS = () => { setEditandoOS(false); setFormEditOS(null); };

  // Sempre que o modal de detalhe muda (fecha ou abre outra OS), sai do
  // modo de edicao -- senao o form de edicao de uma OS "vazaria" pra outra.
  useEffect(() => { setEditandoOS(false); setFormEditOS(null); setMostrarHistoricoOS(false); setHistoricoOS([]); }, [modalDetalhe?.id]);

  const salvarEdicaoOS = async () => {
    if (!modalDetalhe || !formEditOS) return;
    const id = modalDetalhe.id;
    const patch = { ...formEditOS, placa: (formEditOS.placa || "").toUpperCase() };
    setSalvandoEdicaoOS(true);
    try {
      const r = await authFetch("" + API_BASE + "/api/v1/dados/os/" + tenantIdGlobal + "/" + id, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(patch),
      });
      if (r.ok) {
        const nova = lista.map(o => o.id === id ? { ...o, ...patch } : o);
        setLista(nova); salvarHistorico(nova);
        try { localStorage.setItem("os_cache_tenant_" + tenantIdGlobal, JSON.stringify(nova)); } catch (e) { console.warn("os_cache setItem failed (non-fatal):", e); }
        setModalDetalhe(d => d ? { ...d, ...patch } : d);
        setEditandoOS(false);
        setFormEditOS(null);
      } else {
        // AUD-M1: este caminho DESCARTAVA o que o servidor explicou e mostrava
        // so "Tente novamente ou faca login de novo" -- mandando a oficina
        // refazer login por causa de um campo longo demais. O caminho de CRIAR
        // (acima, no salvar da O.S. nova) ja fazia certo; aqui passa a fazer
        // igual: codigo do erro, o detalhe do servidor, e a garantia de que o
        // que foi digitado continua na tela -- que e verdade, este ramo nao
        // limpa formEditOS nem fecha a edicao.
        //
        // A chave nova vem com texto padrao embutido (mesmo padrao ja usado
        // neste arquivo), entao nao depende de traducao nova existir.
        let detalhe = "";
        try { const erroData = await r.json(); detalhe = erroData.detail || erroData.message || JSON.stringify(erroData); }
        catch { detalhe = await r.text().catch(()=>""); }
        detalhe = String(detalhe || "").slice(0, 300);
        alert(t("os.alertas.erro_salvar", "Nao foi possivel salvar as alteracoes.")
              + " (" + r.status + ") " + detalhe
              + " " + (t("os.alertas.dados_preservados") || ""));
      }
    } catch (e) {
      alert((t("os.alertas.falha_conexao_prefix", { erro: e.message || e }) || "Falha de conexao.") + " " + (t("os.alertas.dados_preservados") || ""));
    } finally {
      setSalvandoEdicaoOS(false);
    }
  };

  const carregarHistoricoOS = async (os) => {
    if (!os) return;
    setCarregandoHistoricoOS(true);
    try {
      const r = await authFetch("" + API_BASE + "/api/v1/dados/os/" + tenantIdGlobal + "/" + os.id + "/historico", {});
      const dados = r.ok ? await r.json() : [];
      setHistoricoOS(Array.isArray(dados) ? dados : []);
    } catch (e) {
      setHistoricoOS([]);
    } finally {
      setCarregandoHistoricoOS(false);
    }
  };

  const toggleHistoricoOS = () => {
    const abrindo = !mostrarHistoricoOS;
    setMostrarHistoricoOS(abrindo);
    if (abrindo && modalDetalhe) carregarHistoricoOS(modalDetalhe);
  };

  const limparAntigos = () => {
    const seisM = Date.now() - 180 * 24 * 60 * 60 * 1000;
    const antigas = lista.filter(o => (o._criadoEm || 0) <= seisM);
    const nova = lista.filter(o => (o._criadoEm || 0) > seisM);
    if (antigas.length === 0) { setMsgLimpeza(t("os.alertas.nenhuma_antiga")); setTimeout(()=>setMsgLimpeza(""),3000); return; }
    antigas.forEach(os => moverParaLixeira(os));
    setLixeira(carregarLixeira());
    setLista(nova); salvarHistorico(nova);
    setMsgLimpeza(t("os.alertas.movidas_lixeira", { count: antigas.length }));
    setTimeout(() => setMsgLimpeza(""), 3000);
  };

  const abrirOrcamento = (os) => {
    setObsOrcamento("");
    // Fase 3 -- carrega se este orcamento ja debitou estoque antes (persistido
    // dentro do proprio JSON de orcamento salvo), pra nao debitar de novo se o
    // usuario reabrir/reconfirmar.
    // FIX (2026-09-01): reabrir o orcamento agora carrega os itens/fotos REALMENTE
    // salvos em os.orcamento, em vez da lista de intake (os.servicos) congelada na
    // abertura da OS -- isso evitava que reabrir+pre-visualizar sobrescrevesse o
    // orcamento real com uma lista antiga/vazia.
    let estoqueBaixado = false;
    let orcSalvo = null;
    try { orcSalvo = JSON.parse(os.orcamento || "null"); } catch {}
    estoqueBaixado = !!(orcSalvo && orcSalvo.estoqueBaixado);
    const itensIniciais = (orcSalvo && Array.isArray(orcSalvo.itens) && orcSalvo.itens.length > 0) ? orcSalvo.itens : [...(os.servicos||[])];
    // AUD-G: os mesmos valores de sempre, agora em variaveis, para servirem
    // tambem de ponto de partida da comparacao. Nada mudou no que e carregado.
    const fotosIniciais = (orcSalvo && Array.isArray(orcSalvo.fotos)) ? orcSalvo.fotos : [];
    const dataHoraInicial = (orcSalvo&&orcSalvo.dataHora)||(orcSalvo&&orcSalvo.savedAt)||new Date().toISOString();
    setFotasPremium(fotosIniciais);
    setModalOrcamento({ os:{...os}, itens:itensIniciais, step:1, estoqueBaixado, dataHora:dataHoraInicial });
    setOrcBase(assinaturaOrc(itensIniciais, dataHoraInicial, fotosIniciais));
    setOrcAviso(null);
    setConfirmandoFecharOrc(false);
    setOrcSalvando(false);
    // Fase 2 -- origem da peca: carrega o Estoque real do tenant para o
    // seletor. Falha silenciosa (igual aos outros fetches deste arquivo) --
    // se der erro, a lista de estoque so fica vazia, nada quebra.
    const _tid = getTenantIdFromToken()||"1";
    authFetch(API_BASE+"/api/v1/dados/estoque/"+_tid, {})
      .then(r=>r.ok?r.json():[])
      .then(d=>setEstoqueItens(Array.isArray(d)?d:[]))
      .catch(()=>setEstoqueItens([]));
  };
  const addItemOrc = (item) => setModalOrcamento(m => { if (!m || m.itens.find(i=>i.nome===item.nome)) return m; return { ...m, itens:[...m.itens,{nome:item.nome,preco:item.preco,qtd:1,precoUnit:item.preco,custoUnit:Number(item.custo)||0}] }; });
  const removeItemOrc = (nome) => setModalOrcamento(m => m ? { ...m, itens:m.itens.filter(i=>i.nome!==nome) } : m);
  // 24/09/2026 -- as operacoes da lista "Selecionados" passam a usar POSICAO
  // como chave, nao o nome. Ate aqui todas procuravam o item por `nome`, o
  // que travava a edicao do nome: mexer no nome era mexer no identificador.
  // Havia tambem um risco silencioso -- dois itens com o mesmo nome (o painel
  // de fornecedor nunca checou duplicata) fazem editar ou excluir UM mexer
  // nos DOIS. Por posicao isso deixa de existir, e a ordem do array e
  // exatamente a ordem que o proprietario montou na tela.
  const updateQtdOrc = (indice, qtd) => setModalOrcamento(m => m ? { ...m, itens:m.itens.map((i,ix) => ix===indice ? {...i, qtd:qtd, preco:(i.precoUnit||i.preco)*(Number(qtd)||1)} : i) } : m);
  // Edicao livre de valores, item a item. Mexem sempre no UNITARIO: o campo
  // `preco` e o total da linha e continua sendo preco unitario x quantidade,
  // como updateQtdOrc ja fazia. Guardamos o texto digitado como veio, para
  // a pessoa poder apagar o campo e redigitar sem o cursor pular.
  const updatePrecoUnitOrc = (indice, v) => setModalOrcamento(m => m ? { ...m, itens:m.itens.map((i,ix) => {
    if (ix !== indice) return i;
    const unit = Number(v) || 0;
    return { ...i, precoUnit: v === "" ? "" : unit, preco: unit * (Number(i.qtd) || 1) };
  }) } : m);
  const updateCustoUnitOrc = (indice, v) => setModalOrcamento(m => m ? { ...m, itens:m.itens.map((i,ix) =>
    ix === indice ? { ...i, custoUnit: v === "" ? "" : (Number(v) || 0) } : i
  ) } : m);
  // Nome editavel na propria linha. O dono errava uma letra e, depois de
  // salvo, a unica saida era excluir e reinserir -- e o item reinserido ia
  // para o fim da lista, desmanchando a sequencia que ele montou. Guarda o
  // texto exatamente como foi digitado, sem trim, para nao travar o espaco
  // no meio do nome; o trim e a protecao contra nome vazio ficam no blur do
  // campo, que e onde a edicao termina.
  const updateNomeItemOrc = (indice, v) => setModalOrcamento(m => m ? { ...m, itens:m.itens.map((i,ix) =>
    ix === indice ? { ...i, nome: v } : i
  ) } : m);
  // Exclusao por posicao -- funcao NOVA e aditiva. removeItemOrc(nome)
  // continua existindo e intacta, porque o Catalogo de Servicos e o painel
  // de Estoque chamam por nome e nenhum dos dois muda aqui.
  const removeItemOrcIndice = (indice) => setModalOrcamento(m => m ? { ...m, itens:m.itens.filter((_, ix) => ix !== indice) } : m);
  // Fase 2 -- origem da peca: adiciona item vindo do Estoque real, marcado
  // com origem/estoqueId (usado nas proximas fases para deducao automatica
  // ao confirmar o orcamento). Mesma forma {nome,preco,qtd,precoUnit} dos
  // itens existentes -- nao quebra a lista "Selecionados", o total nem a
  // impressao, que so leem nome/qtd/preco.
  const addItemEstoque = (it) => setModalOrcamento(m => {
    if (!m || m.itens.find(i=>i.estoqueId===it.id)) return m;
    const preco = Number(it.preco)||0;
    // O custo ja esta no cadastro do estoque e ate aqui ficava para tras --
    // sem ele nao havia como calcular ganho de peca de estoque numa O.S.
    // O backend devolve "preco_custo"; a tela de Estoque chama de "custo".
    // Aceita os dois nomes para nao depender de qual veio.
    const custoUnit = Number(it.preco_custo != null ? it.preco_custo : it.custo) || 0;
    return { ...m, itens:[...m.itens, { nome:it.nome, preco, qtd:1, precoUnit:preco, custoUnit, origem:"estoque_interno", estoqueId:it.id }] };
  });
  // Peca de compra direta em fornecedor -- nao debita Estoque (nao veio
  // dele), so registra o item no orcamento com dados de custo/fornecedor
  // para as proximas fases (Financeiro/margem).
  const addItemFornecedor = () => {
    const nome = formFornecedor.nome.trim();
    const preco = Number(formFornecedor.preco)||0;
    const qtd = Number(formFornecedor.qtd)||1;
    if (!nome || !preco) return;
    setModalOrcamento(m => m ? { ...m, itens:[...m.itens, {
      nome, preco:preco*qtd, qtd, precoUnit:preco,
      origem:"compra_fornecedor", fornecedor:formFornecedor.fornecedor||"", custoUnit:Number(formFornecedor.custo)||0,
    }] } : m);
    setFormFornecedor({ nome:"", fornecedor:"", custo:"", preco:"", qtd:"1" });
  };
  const confirmarOrcamento = (irParaPrevia) => {
    if (!modalOrcamento) return Promise.resolve(false);
    const total = modalOrcamento.itens.reduce((a,i)=>a+(Number(i.preco)||0),0);
    const nova = lista.map(o => o.id===modalOrcamento.os.id ? {...o,servicos:modalOrcamento.itens,total} : o);
    setLista(nova); salvarHistorico(nova);
    // Salvar orcamento no banco
    const tenantId = getTenantIdFromToken()||"1";
    // Fase 4 (02/09/2026, pedido do Abima) -- a baixa automatica de estoque
    // NAO acontece mais aqui. Se o cliente confirma o orcamento mas desiste
    // antes do servico ser executado, o estoque nao pode ter sido mexido --
    // por isso a deducao foi movida para confirmarConclusao(), o unico ponto
    // que representa a peca de fato saindo da prateleira. estoqueBaixado
    // (jaBaixado) e so preservado aqui, nunca setado, pra nao perder o
    // registro se o usuario reabrir/editar um orcamento de uma OS ja
    // concluida.
    const jaBaixado = !!modalOrcamento.estoqueBaixado;
    const orcData = {orcamento: JSON.stringify({itens:modalOrcamento.itens,total,modelo:modeloOrc,fotos:fotasPremium,savedAt:new Date().toISOString(),estoqueBaixado:jaBaixado,dataHora:modalOrcamento.dataHora||new Date().toISOString()}), orcamento_modelo: modeloOrc, total};
    // AUD-G: a assinatura do que esta indo para o servidor. So vira a nova
    // referencia de "salvo" se ele ACEITAR. Ate 24/09 a resposta era ignorada
    // e um 409 (a trava que impede sobrescrever orcamento cheio com vazio)
    // passava por sucesso.
    const assinaturaEnviada = assinaturaOrc(modalOrcamento.itens, modalOrcamento.dataHora, fotasPremium);
    // Recarga da lista a partir do banco -- feita nos DOIS caminhos, para a
    // tela nunca ficar mostrando um total que o banco nao tem.
    const recarregar = () => authFetch(""+API_BASE+"/api/v1/dados/os/"+tenantId, {})
        .then(r=>r.ok?r.json():[])
        .then(d=>{if(Array.isArray(d)&&d.length>0){setLista(d);salvarHistorico(d);try{localStorage.setItem("os_cache_tenant_"+tenantId,JSON.stringify(d));}catch(e){}}})
        .catch(()=>{});
    setOrcSalvando(true);
    setOrcAviso(null);
    const envio = authFetch(`${API_BASE}/api/v1/dados/os/${tenantId}/${modalOrcamento.os.id}/orcamento`, {
      method:"PATCH",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify(orcData)
    }).then((r)=>{
      if (!r || !r.ok) {
        const st = r && r.status ? " (" + r.status + ")" : "";
        setOrcAviso({ tipo:"erro", texto: t("os.orc.erro_salvar", "O servidor recusou a gravacao. Nada foi perdido -- suas alteracoes continuam na tela.") + st });
        recarregar();
        return false;
      }
      setOrcBase(assinaturaEnviada);
      setOrcAviso({ tipo:"ok", texto: t("os.orc.salvo_ok", "Orcamento gravado.") });
      recarregar();
      return true;
    }).catch(()=>{
      setOrcAviso({ tipo:"erro", texto: t("os.orc.erro_rede", "Sem resposta do servidor. O orcamento NAO foi gravado -- suas alteracoes continuam na tela.") });
      recarregar();
      return false;
    }).then((ok)=>{ setOrcSalvando(false); return ok; });
    setModalOrcamento(m => ({...m, os:{...m.os,servicos:m.itens,total}, step: irParaPrevia ? 2 : m.step, estoqueBaixado:jaBaixado}));
    return envio;
  };
  // AUD-G: fechar com pendencia nao descarta mais em silencio -- pergunta.
  const fecharOrcamento = () => {
    if (orcSujo) { setConfirmandoFecharOrc(true); return; }
    setConfirmandoFecharOrc(false);
    setOrcAviso(null);
    setModalOrcamento(null);
  };
  const isoToLocalInput = (iso) => { try { const d = iso ? new Date(iso) : new Date(); if (isNaN(d.getTime())) return ""; const off = d.getTimezoneOffset(); const local = new Date(d.getTime()-off*60000); return local.toISOString().slice(0,16); } catch(e) { return ""; } };
  const fmtDataHoraOrc = (iso) => { try { const d = iso ? new Date(iso) : new Date(); if (isNaN(d.getTime())) return new Date().toLocaleDateString("pt-BR"); return d.toLocaleDateString("pt-BR") + " " + d.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}); } catch(e) { return new Date().toLocaleDateString("pt-BR"); } };
  // AUD-S (30/09/2026) -- o dialogo de impressao mostrava 3 paginas para um
  // documento de 1. As paginas extras NAO eram copias do orcamento: eram a
  // tela de fundo. A regra @media print do global.css usa
  // `body * { visibility: hidden }`, e visibility:hidden esconde o elemento
  // mas nao o tira do layout -- a lista de O.S. continua ocupando altura e
  // virando pagina em branco depois do documento.
  //
  // Medido em Chromium 141, variando o tamanho da lista de fundo:
  //     0 O.S. -> 1 pagina        47 O.S. -> 3 paginas  (a oficina hoje)
  //    10 O.S. -> 1 pagina       120 O.S. -> 8 paginas
  // Piora sozinho conforme a oficina acumula O.S.
  //
  // A saida e a MESMA tecnica que o ModalOrcamentoCompleto.js ja usa em
  // producao: janela limpa + outerHTML do documento. Assim nao sobra nada no
  // documento impresso para ocupar altura, e a pagina extra fica
  // estruturalmente impossivel -- nao depende de acertar a causa, depende de
  // nao haver mais nada la dentro.
  //
  // O caminho antigo continua como reserva para o caso de o navegador barrar
  // a janela (bloqueador de pop-up). Nessa situacao o resultado e o de hoje,
  // nunca pior.
  const imprimirDoc = (pb) => {
    const el = document.getElementById("print-doc");
    if (!el) return;
    setModalImpressao(false);
    const ref = (modalOrcamento && modalOrcamento.os && modalOrcamento.os.id) || "";
    const win = window.open("", "_blank", "width=900,height=700");
    if (!win) {
      // pop-up bloqueado: cai no comportamento anterior, identico ao de hoje.
      el.style.filter = pb ? "grayscale(100%)" : "none";
      setTimeout(() => { window.print(); setTimeout(() => { el.style.filter = "none"; }, 500); }, 100);
      return;
    }
    // AUD-O6 (14/10/2026) -- qualidade do documento impresso.
    //
    // O cliente de uma oficina reclamou de "letras pequenas, layout fraco".
    // Medido, ele estava certo, e por dois motivos independentes:
    //
    // 1. "print-color-adjust" nao existia neste arquivo. Sem ela o Chrome
    //    NAO imprime fundo colorido -- o cabecalho grafite, os cartoes
    //    escuros, a faixa da tabela e a barra do total saiam BRANCOS. O
    //    documento perdia a estrutura inteira no caminho da tela para o
    //    papel. Confirmado imprimindo de verdade.
    // 2. O documento e desenhado em pixels de tela e impresso como esta:
    //    o corpo ficava entre 8,25pt e 9,75pt, contra os 10-11pt de um
    //    documento profissional.
    //
    // O zoom de 1.15 aumenta TUDO junto, preservando a hierarquia -- ajustar
    // tamanho a tamanho achataria o desenho. O bloco tem largura automatica,
    // entao continua preenchendo a pagina depois do zoom: nada estoura a
    // margem (verificado em impressao real, 14/10).
    //
    // O cabecalho e o rodape do proprio navegador (data, URL, "2/2") NAO sao
    // controlaveis por CSS -- sao a caixinha "Cabecalhos e rodapes" da janela
    // de impressao. Por isso o rodape proprio abaixo carrega os dados que
    // importam, para que aquela opcao possa ser desligada sem perda.
    const esc = (v) => String(v == null ? "" : v)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
    const rodapeEsq = [
      orcCfg && orcCfg.nomeEmpresa,
      orcCfg && orcCfg.documento ? "CNPJ/CPF " + orcCfg.documento : "",
      orcCfg && orcCfg.telefone,
    ].filter(Boolean).map(esc).join(" &middot; ");
    const rodapeDir = [ref, new Date().toLocaleDateString("pt-BR")]
      .filter(Boolean).map(esc).join(" &middot; ");
    // Sem condicional de proposito: a data entra sempre, entao o rodape
    // sempre existe. Um "if" aqui seria ramo morto -- um mutante que o
    // apagou passou incolume pela bateria, e ramo que nenhum teste alcanca
    // e justamente o que apodrece sem ninguem ver.
    const rodape = "<div class='rodape-o6'><span>" + rodapeEsq +
                   "</span><span>" + rodapeDir + "</span></div>";
    win.document.write(
      "<!DOCTYPE html><html><head><meta charset='utf-8'><title>" +
      (ref ? "Orcamento " + ref : "Orcamento") +
      "</title><style>" +
      "@page{size:A4;margin:14mm 14mm 16mm}" +
      "body{margin:0;background:#fff" + (pb ? ";filter:grayscale(100%)" : "") + "}" +
      "#print-doc{zoom:1.15}" +
      "#print-doc,#print-doc *{-webkit-print-color-adjust:exact !important;print-color-adjust:exact !important}" +
      // Os modelos montam as linhas da tabela com display:grid. Como eu nao
      // posso tocar neles aqui, alcanco a regra pelo proprio estilo em
      // linha -- assim nenhuma linha, nenhum cartao e nenhum bloco de
      // assinatura e cortado ao meio na virada de pagina.
      "#print-doc [style*='display: grid'],#print-doc tr,#print-doc img" +
      "{break-inside:avoid;page-break-inside:avoid}" +
      ".rodape-o6{display:flex;justify-content:space-between;gap:12px;" +
      "margin-top:10mm;padding-top:3mm;border-top:1px solid #cbd5e1;" +
      "color:#64748b;font:8.5pt Arial,Helvetica,sans-serif}" +
      "</style></head><body>" + el.outerHTML + rodape + "</body></html>"
    );
    win.document.close();
    win.focus();
    const disparar = () => { win.print(); };
    // Aguarda o logo e as fotos carregarem, senao a impressao sai sem imagem.
    const imgs = win.document.images;
    if (imgs && imgs.length > 0) {
      let restantes = imgs.length;
      const done = () => { if (--restantes <= 0) setTimeout(disparar, 100); };
      for (let i = 0; i < imgs.length; i++) {
        if (imgs[i].complete) done();
        else { imgs[i].onload = done; imgs[i].onerror = done; }
      }
    } else {
      setTimeout(disparar, 150);
    }
  };
  // AUD-O4 (14/10/2026) -- tons derivados da Cor Principal da oficina.
  //
  // Ate aqui o Profissional e o Premium tinham paleta fixa no codigo:
  // medido, "corDocumento" aparecia 5x no Basico e ZERO nos outros dois.
  // A "Cor Principal" era uma promessa que a tela do admin fazia e o
  // documento do cliente nao cumpria.
  //
  // O que NAO muda: o grafite do Premium e a identidade daquele modelo e
  // continua grafite. So o acento vira a cor da oficina.
  const _hexRGB = (h) => {
    const m = /^#([0-9a-fA-F]{6})$/.exec(String(h || "").trim());
    if (!m) return null;
    const n = parseInt(m[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  };
  // O azul historico e a rede de seguranca: cor ausente ou invalida nunca
  // pode gerar documento quebrado na frente do cliente da oficina.
  const corP = () => {
    const c = orcCfg && orcCfg.corDocumento;
    return _hexRGB(c) ? c : "#1e40af";
  };
  // Luminancia relativa (WCAG). Nao e enfeite: e com ela que as duas
  // funcoes abaixo garantem que o documento saia LEGIVEL com qualquer cor
  // que a oficina escolher, inclusive preto puro e amarelo claro.
  const _lum = (c) => {
    const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2]);
  };
  const _razao = (a, b) => {
    const la = _lum(a), lb = _lum(b);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
  };
  const _rgb = (c) => "rgb(" + c[0] + "," + c[1] + "," + c[2] + ")";
  // Acento sobre o GRAFITE do Premium. Clarear uma porcentagem fixa nao
  // serve: preto puro clareado 45% da 3,77 de contraste contra #0f172a, e
  // isso e texto que ninguem le. Aqui clareamos ATE passar de 4,5 (o
  // minimo da WCAG), parando no branco.
  const corNoEscuro = () => {
    const base = _hexRGB(corP());
    for (let f = 0.45; f <= 1.0001; f += 0.05) {
      const p = (v) => Math.round(v + (255 - v) * f);
      const c = [p(base[0]), p(base[1]), p(base[2])];
      if (_razao(c, [15, 23, 42]) >= 4.5) return _rgb(c);
    }
    return "rgb(255,255,255)";
  };
  // A cor onde ela e TEXTO sobre branco, ou FUNDO carregando texto branco
  // (cabecalho, cabecalho da tabela, barra de total). Mesmo requisito nos
  // dois casos: 4,5 contra o branco. Uma oficina que escolher amarelo
  // claro teria cabecalho ilegivel; aqui a cor escurece ate servir.
  const corSegura = () => {
    const base = _hexRGB(corP());
    for (let f = 0; f <= 1.0001; f += 0.05) {
      const p = (v) => Math.round(v * (1 - f));
      const c = [p(base[0]), p(base[1]), p(base[2])];
      if (_razao(c, [255, 255, 255]) >= 4.5) return _rgb(c);
    }
    return "rgb(0,0,0)";
  };
  // Escurece um pouco -- so para o segundo tom do degrade do cabecalho.
  // Escurecer (em vez de clarear) mantem o texto branco legivel de ponta
  // a ponta do degrade.
  const corEscura = (f) => {
    const m = /^rgb\((\d+),(\d+),(\d+)\)$/.exec(corSegura());
    const c = [Number(m[1]), Number(m[2]), Number(m[3])];
    const p = (v) => Math.round(v * (1 - f));
    return _rgb([p(c[0]), p(c[1]), p(c[2])]);
  };
  // A mesma cor, transparente: serve de preenchimento e de borda sem
  // precisar inventar um segundo tom que brigue com a cor da oficina.
  const corAlfa = (a) => {
    const r = _hexRGB(corP());
    return "rgba(" + r[0] + "," + r[1] + "," + r[2] + "," + a + ")";
  };
  const getFundoStyle = () => {
    if (!orcCfg) return { background:"#fff" };
    if (orcCfg.fundoTipo==="cor") return { background:orcCfg.fundoCor||"#fff" };
    if (orcCfg.fundoTipo==="gradiente") return { background:"linear-gradient("+(orcCfg.fundoGradienteDirecao||"135deg")+","+(orcCfg.fundoGradienteA||"#e0e7ff")+","+(orcCfg.fundoGradienteB||"#ffffff")+")" };
    // AUD-O4: o ramo que faltava. "fundoUrl" nao aparecia uma unica vez
    // neste arquivo -- a opcao "Imagem" do painel era configuravel, era
    // guardada no banco (1,45 MB na oficina 2) e nunca chegava ao
    // documento.
    //
    // A opacidade e simulada por um veu branco por cima da imagem, e nao
    // por um <img> posicionado: assim nada novo entra dentro de
    // #print-doc, que e o elemento que o navegador transforma em PDF.
    if (orcCfg.fundoTipo==="imagem" && orcCfg.fundoUrl) {
      const o = Number(orcCfg.fundoOpacidade);
      const veu = 1 - ((isFinite(o) && o >= 0 && o <= 1) ? o : 0.12);
      return {
        backgroundImage: "linear-gradient(rgba(255,255,255,"+veu+"),rgba(255,255,255,"+veu+")), url("+orcCfg.fundoUrl+")",
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    }
    return { background:"#fff" };
  };

  const filtradas = lista.filter(os =>
    (filtroStatus==="Todos" || os.status===filtroStatus) &&
    (!busca || os.cliente?.toLowerCase().includes(busca.toLowerCase()) || os.placa?.toLowerCase().includes(busca.toLowerCase()) || os.id?.includes(busca))
  );
  const totais = STATUS_FLOW.reduce((acc,s)=>({...acc,[s]:lista.filter(o=>o.status===s).length}),{});
  const nomesServicos = (os) => itensDaOS(os).map(s=>typeof s==="string"?s:s.nome);
  // O mesmo documento serve a duas finalidades: enquanto o servico nao
  // terminou ele e uma proposta do que SERA feito; depois de concluido ou
  // entregue ele e a comprovacao do que FOI feito. Ate aqui ele se anunciava
  // como orcamento nos dois casos -- e orcamento e coisa que ainda vai
  // acontecer. Os status vem do STATUS_FLOW ja definido no topo do arquivo.
  const _statusOrc = modalOrcamento && modalOrcamento.os ? modalOrcamento.os.status : null;
  // AUD-O8: "servicoConcluido" saiu daqui -- quem decide o momento agora e
  // a tabela _MOMENTOS_POR_STATUS, logo abaixo.
  // AUD-O7a (14/10/2026) -- de dois momentos para TRES, e os nomes saem da
  // configuracao da oficina.
  //
  // Faltava o momento do meio: servico ja APROVADO e em execucao. Ate aqui
  // ele se anunciava como proposta, e proposta e coisa que o cliente ainda
  // vai aprovar -- ele ja aprovou.
  //
  // O momento continua vindo do STATUS da O.S., de proposito: assim o dono
  // escolhe as PALAVRAS e o sistema escolhe o MOMENTO. Deixar o rotulo ser
  // escolhido a mao, documento a documento, permitiria entregar um
  // "comprovante de servico" de um servico que nao foi feito -- papel
  // assinado afirmando o que nao aconteceu.
  //
  // Sem nada configurado, sai exatamente o que ja saia no Basico. O
  // Profissional e o Premium passam a dizer o mesmo que ele: o nome do
  // documento e do MOMENTO, nao do desenho escolhido.
  // AUD-O8 (14/10/2026) -- de tres para QUATRO momentos.
  //
  // O "servicoConcluido" saiu daqui: com a tabela abaixo ele deixou de ter
  // leitor. Variavel sem uso NAO e inofensiva neste projeto -- o build do
  // CRA com CI=true trata como erro e derruba o deploy. A unica linha da
  // base removida neste AUD, e removida por necessidade.
  //
  // O AUD-O7a juntava "ainda apurando" e "orcamento ja enviado, aguardando
  // o sim" num nome so. Sao papeis diferentes: no segundo o cliente ja tem
  // a proposta na mao. Agora o documento se chama ORCAMENTO exatamente no
  // momento em que ele E um orcamento.
  //
  // O que NAO muda: COMPROVANTE sai so em Concluido/Entregue. Emitir
  // comprovante de servico ainda nao executado seria o sistema ajudando a
  // produzir prova do que nao aconteceu -- e e por isso que o momento vem
  // do status e nunca de uma escolha de tela.
  //
  // Cada momento mapeia um GRUPO de status, declarado numa tabela unica:
  // acrescentar um status novo amanha e acrescentar uma linha aqui, e nao
  // cacar condicoes espalhadas.
  const _MOMENTO_PRE = "pre", _MOMENTO_ORCAMENTO = "orcamento";
  const _MOMENTO_ABERTA = "aberta", _MOMENTO_FIM = "fim";
  const _MOMENTOS_POR_STATUS = {
    "Recepcao":             _MOMENTO_PRE,
    "Diagnostico":          _MOMENTO_PRE,
    "Aguardando Aprovacao": _MOMENTO_ORCAMENTO,
    "Aguardando Pecas":     _MOMENTO_ABERTA,
    "Em Servico":           _MOMENTO_ABERTA,
    "Concluido":            _MOMENTO_FIM,
    "Entregue":             _MOMENTO_FIM,
  };
  // Status desconhecido, nulo ou O.S. ausente caem em PRE: o documento mais
  // inofensivo dos quatro. Errar para o lado da proposta nao cria papel
  // falso; errar para o lado do comprovante, sim.
  const _momentoDoc = _MOMENTOS_POR_STATUS[_statusOrc] || _MOMENTO_PRE;
  const _rotuloPadrao = (k) => (
    k === _MOMENTO_FIM       ? t("os.orc.doc.badge_comprovante", "COMPROVANTE DE SERVIÇO") :
    k === _MOMENTO_ABERTA    ? t("os.orc.doc.badge_os_aberta", "ORDEM DE SERVIÇO") :
    k === _MOMENTO_ORCAMENTO ? t("os.orc.doc.badge_orcamento") :
                               t("os.orc.doc.badge_pre_orcamento", "PRÉ-ORÇAMENTO")
  );
  const rotuloDocOS = (() => {
    const r = orcCfg && orcCfg.rotulosDoc;
    // Sem checar o tipo de "r" de proposito: se vier texto ou numero no
    // lugar do objeto, r[_momentoDoc] ja e undefined e cai no padrao. Um
    // "typeof === object" aqui seria guarda que nao guarda nada -- um
    // mutante que a apagou passou incolume pela bateria.
    const v = r ? r[_momentoDoc] : null;
    // So troca por texto de verdade: "", "   " e qualquer coisa que nao seja
    // string caem no padrao, em vez de imprimir um cabecalho vazio.
    return (typeof v === "string" && v.trim()) ? v.trim() : _rotuloPadrao(_momentoDoc);
  })();

  const catalogoCompleto = () => {
    const extras = [];
    if (orcCfg?.tipos) orcCfg.tipos.forEach(t=>(t.itens||[]).forEach(i=>{if(!SERVICOS_CATALOGO.find(b=>b.nome===i.nome))extras.push({nome:i.nome,preco:Number(i.preco)||0});}));
    return [...SERVICOS_CATALOGO,...extras];
  };

  return (
    <Layout>
      <div style={{display:"flex",flexDirection:"column",gap:20}}>
        <div style={{alignItems:"flex-start",display:"flex",justifyContent:"space-between"}}>
          <div>
            <div style={{alignItems:"center",display:"flex",gap:8}}><h1 style={{fontSize:22,fontWeight:700}}>{t("os.titulo")}</h1><BotaoDica id="os" /></div>
            <p style={{color:"var(--text2)",fontSize:13,marginTop:3}}>{t("os.subtitulo_count",{count:lista.length})}</p>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            {msgLimpeza && <span style={{color:"#22c55e",fontSize:12}}>{msgLimpeza}</span>}
            <button className="btn-ghost" onClick={limparAntigos} style={{fontSize:12,padding:"8px 14px"}}>{t("os.limpar_antigos")}</button>
            <button className="btn-ghost" onClick={()=>{setLixeira(carregarLixeira());setErroRestaurar("");setModalLixeira(true);}} style={{fontSize:12,padding:"8px 14px",color:"#ef4444",border:"1px solid #ef444444"}}>
              {t("os.lixeira")} {lixeira.length > 0 && <span style={{background:"#ef4444",borderRadius:99,color:"#fff",fontSize:10,fontWeight:700,marginLeft:4,padding:"1px 6px"}}>{lixeira.length}</span>}
            </button>
            <button className="btn-ghost" onClick={()=>exportarCSV(lista)} style={{fontSize:12,padding:"8px 14px"}}>{t("os.exportar_csv")}</button>
            {temRelatorioFree && (
              <button onClick={()=>exportarHTML(lista, localStorage.getItem("tenant_nome")||"Minha Empresa")}
                style={{fontSize:12,padding:"8px 14px",background:"linear-gradient(135deg,#6366f122,#3b82f622)",border:"1px solid #6366f155",borderRadius:8,color:"#818cf8",cursor:"pointer"}}>
                {t("os.relatorio_html")}
              </button>
            )}
            <button className="btn-primary" onClick={()=>setModalNova(true)} style={{fontSize:13,padding:"10px 18px"}}>{t("os.nova_os_btn")}</button>
          </div>
        </div>

        <Dica id="os" jaUsou={lista.length > 0}
          texto={t("dicas.os", "O coração da sua oficina. Cada carro que chega vira uma O.S. Comece abrindo a primeira em “+Nova O.S”.")} />

        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {["Todos",...STATUS_FLOW].map(s => {
            const ativo = filtroStatus===s; const cor = STATUS_COR[s];
            return (
              <button key={s} onClick={()=>setFiltroStatus(s)} style={{alignItems:"center",display:"flex",gap:6,background:ativo?(cor?.bg||"#3b82f622"):"var(--bg3)",border:"2px solid "+(ativo?(cor?.dot||"#3b82f6"):"var(--border)"),borderRadius:20,color:ativo?(cor?.cor||"#60a5fa"):"var(--text2)",cursor:"pointer",fontSize:12,fontWeight:ativo?700:400,padding:"5px 14px",whiteSpace:"nowrap"}}>
                {s==="Todos"?t("os.todos"):STATUS_LABEL(s)}{s!=="Todos"&&totais[s]>0&&<span style={{background:cor?.dot,borderRadius:99,color:"#fff",fontSize:10,fontWeight:700,minWidth:18,padding:"1px 7px",textAlign:"center"}}>{totais[s]}</span>}
              </button>
            );
          })}
        </div>

        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <div style={{display:"flex",gap:4}}>
            {["lista","kanban"].map(tb=>(
              <button key={tb} onClick={()=>setTab(tb)} style={{background:tab===tb?"var(--accent)":"var(--bg3)",border:"1px solid "+(tab===tb?"var(--accent)":"var(--border)"),borderRadius:8,color:tab===tb?"#fff":"var(--text2)",cursor:"pointer",fontSize:12,fontWeight:tab===tb?600:400,padding:"8px 16px"}}>{tb==="lista"?t("os.tab_lista"):t("os.tab_kanban")}</button>
            ))}
          </div>
        </div>

        {tab==="lista" && (
          <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:"var(--radius)",overflow:"auto"}}>
            <table style={{borderCollapse:"collapse",minWidth:900,width:"100%"}}>
              <thead><tr style={{background:"var(--bg4)"}}>
                {[t("os.col_os"),t("os.col_cliente"),tSeg("os.col_veiculo"),t("os.col_placa"),t("os.col_servicos"),t("os.col_tecnico"),t("os.col_total"),t("os.col_status"),t("os.col_acoes")].map(h=>(
                  <th key={h} style={{color:"var(--text2)",fontSize:11,fontWeight:600,letterSpacing:"0.07em",padding:"12px 14px",textAlign:"left",textTransform:"uppercase",whiteSpace:"nowrap"}}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {filtradas.map(os => {
                  const cor = STATUS_COR[os.status]||STATUS_COR["Recepcao"];
                  const nomes = nomesServicos(os);
                  const exp = expandida===os.id;
                  return (
                    <React.Fragment key={os.id}>
                      <tr onClick={()=>setExpandida(exp?null:os.id)} style={{borderTop:"1px solid var(--border)",cursor:"pointer"}} onMouseOver={e=>e.currentTarget.style.background="var(--bg4)"} onMouseOut={e=>e.currentTarget.style.background=""}>
                        <td style={{fontFamily:"monospace",fontSize:12,fontWeight:600,padding:"12px 14px"}}>{os.id}</td>
                        <td style={{fontSize:13,padding:"12px 14px"}}><div style={{fontWeight:500}}>{os.cliente}</div>{os.telefone&&<div style={{color:"var(--text3)",fontSize:11}}>{os.telefone}</div>}</td>
                        <td style={{color:"var(--text2)",fontSize:12,padding:"12px 14px"}}>{os.veiculo}</td>
                        <td style={{padding:"12px 14px"}}><span style={{background:"var(--bg4)",borderRadius:4,fontFamily:"monospace",fontSize:11,fontWeight:700,padding:"3px 8px"}}>{os.placa}</span></td>
                        <td style={{color:"var(--text2)",fontSize:12,maxWidth:180,padding:"12px 14px"}}><div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{nomes.slice(0,2).join(", ")}{nomes.length>2?" +"+(nomes.length-2):""}</div></td>
                        <td style={{color:"var(--text2)",fontSize:12,padding:"12px 14px"}}>{os.tecnico}</td>
                        <td style={{color:"var(--green)",fontSize:13,fontWeight:600,padding:"12px 14px"}}>{os.total>0?"R$ "+os.total.toFixed(2):"-"}</td>
                        <td style={{padding:"12px 14px"}}><span style={{background:cor.bg,borderRadius:20,color:cor.cor,fontSize:11,fontWeight:600,padding:"4px 10px",whiteSpace:"nowrap"}}>{STATUS_LABEL(os.status)}</span></td>
                        <td style={{padding:"12px 14px"}}>
                          <div style={{display:"flex",gap:6}}>
                            <button onClick={e=>{e.stopPropagation();setModalDetalhe(os);}} style={{background:"var(--bg4)",border:"none",borderRadius:6,color:"var(--text2)",cursor:"pointer",fontSize:11,padding:"5px 10px"}}>{t("os.btn_detalhes")}</button>
                            <button onClick={e=>{e.stopPropagation();abrirOrcamento(os);}} style={{background:"var(--accent)22",border:"1px solid var(--accent)",borderRadius:6,color:"var(--accent)",cursor:"pointer",fontSize:11,padding:"5px 10px"}}>{t("os.btn_orcamento")}</button>
                          </div>
                        </td>
                      </tr>
                      {exp && (
                        <tr>
                          <td colSpan={9} style={{background:"var(--bg4)",borderTop:"1px solid var(--border)",padding:"14px 20px"}}>
                            <div style={{display:"grid",gap:16,gridTemplateColumns:"1fr 1fr 1fr"}}>
                              <div><div style={{color:"var(--text3)",fontSize:11,marginBottom:4}}>{t("os.relato_cliente_upper")}</div><div style={{fontSize:13}}>{os.relatoCliente||"-"}</div></div>
                              <div><div style={{color:"var(--text3)",fontSize:11,marginBottom:4}}>{t("os.observacoes_upper")}</div><div style={{fontSize:13}}>{os.obs||"-"}</div></div>
                              <div><div style={{color:"var(--text3)",fontSize:11,marginBottom:4}}>{t("os.servicos_upper")}</div><div style={{fontSize:13}}>{nomes.join(", ")||"-"}</div></div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {tab==="kanban" && (
          <div style={{display:"flex",flexWrap:"wrap",gap:12,paddingBottom:8}}>
            {STATUS_FLOW.map(status => {
              const cor = STATUS_COR[status];
              const oss = filtradas.filter(o=>o.status===status);
              return (
                <div key={status} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,flex:"1 1 200px",minWidth:180,maxWidth:280,padding:12}}>
                  <div style={{alignItems:"center",display:"flex",gap:6,marginBottom:12}}>
                    <div style={{background:cor.dot,borderRadius:99,height:8,width:8}} />
                    <span style={{color:cor.cor,fontSize:12,fontWeight:700}}>{STATUS_LABEL(status)}</span>
                    <span style={{background:cor.bg,borderRadius:99,color:cor.cor,fontSize:10,fontWeight:700,marginLeft:"auto",padding:"1px 8px"}}>{oss.length}</span>
                  </div>
                  {oss.map(os=><CardKanban key={os.id} os={os} onClick={()=>setModalDetalhe(os)} />)}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {modalNova && (
        <Modal onClose={()=>setModalNova(false)} largura={700}>
          <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
            <div><div style={{color:"var(--accent2)",fontSize:12,marginBottom:4}}>{t("os.nova.triagem")}</div><div style={{fontSize:18,fontWeight:800}}>{t("os.nova.titulo")}</div></div>
            <BtnFechar onClick={()=>setModalNova(false)} />
          </div>
          <div style={{display:"grid",gap:16,gridTemplateColumns:"1fr 1fr"}}>
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
              <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,letterSpacing:"0.06em",marginBottom:12,textTransform:"uppercase"}}>{t("os.nova.dados_cliente")}</div>
              {[{c:"cliente",l:t("os.nova.nome_completo"),p:t("os.nova.nome_completo_placeholder")},{c:"telefone",l:t("os.nova.telefone"),p:t("os.nova.telefone_placeholder")},{c:"cpf",l:t("os.nova.cpf_cnpj"),p:t("os.nova.cpf_placeholder")}].map(f=>(
                <div key={f.c} style={{marginBottom:10}}>
                  <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4}}>{f.l}</label>
                  <input value={form[f.c]} onChange={e=>upd(f.c,fmt(f.c,e.target.value))} placeholder={f.p} maxLength={_LIMITE_CAMPO[f.c]} style={{width:"100%"}} />
                </div>
              ))}
            </div>
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
              <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,letterSpacing:"0.06em",marginBottom:12,textTransform:"uppercase"}}>{tSeg("os.nova.dados_veiculo")}</div>
              {[{c:"veiculo",l:tSeg("os.nova.veiculo"),p:t("os.nova.veiculo_placeholder")},{c:"placa",l:t("os.nova.placa"),p:t("os.nova.placa_placeholder")},{c:"km",l:t("os.nova.km"),p:t("os.nova.km_placeholder")},{c:"tecnico",l:t("os.nova.tecnico"),p:t("os.nova.tecnico_placeholder")}].map(f=>(
                <div key={f.c} style={{marginBottom:10}}>
                  <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4}}>{f.l}</label>
                  <input value={form[f.c]} onChange={e=>upd(f.c,fmt(f.c,e.target.value))} placeholder={f.p} maxLength={_LIMITE_CAMPO[f.c]} style={{width:"100%"}} />
                </div>
              ))}
            </div>
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
              <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,letterSpacing:"0.06em",marginBottom:12,textTransform:"uppercase"}}>{t("os.nova.relato_cliente")}</div>
              <textarea value={form.relatoCliente} onChange={e=>upd("relatoCliente",e.target.value)} placeholder={t("os.nova.relato_placeholder")} rows={3} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text)",fontFamily:"inherit",fontSize:13,outline:"none",padding:"10px 12px",resize:"vertical",width:"100%"}} />
            </div>
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
              <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:10}}>
                <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,letterSpacing:"0.06em",textTransform:"uppercase"}}>{t("os.nova.servicos_solicitados")}</div>
                <span style={{color:"var(--text3)",fontSize:10}}>{t("os.nova.selecionados",{count:form.servicosSolicitados.length})}</span>
              </div>
              <input placeholder={t("os.nova.buscar_servico")} value={form._buscaServico||""} onChange={e=>upd("_buscaServico",e.target.value)} style={{marginBottom:8,width:"100%",fontSize:12,padding:"6px 10px"}} />
              <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
                {[{v:"Todos",l:t("os.todos")},{v:"Mao de Obra",l:t("os.nova.filtro_mao_obra")},{v:"Peca",l:t("os.nova.filtro_peca")}].map(ft=>(
                  <button key={ft.v} onClick={()=>upd("_filtroTipo",ft.v)}
                    style={{background:(form._filtroTipo||"Todos")===ft.v?"var(--accent)":"var(--bg4)",border:"none",borderRadius:20,color:(form._filtroTipo||"Todos")===ft.v?"#fff":"var(--text2)",cursor:"pointer",fontSize:10,fontWeight:600,padding:"3px 10px"}}>
                    {ft.l}
                  </button>
                ))}
              </div>
              <div style={{...rolo(200),display:"flex",flexDirection:"column",gap:4}}>
                {getServicosInteligentes(SERVICOS_CATALOGO).filter(s=>{
                  const q=(form._buscaServico||"").toLowerCase();
                  const tipoOk=(form._filtroTipo||"Todos")==="Todos"||(s.tipo||"Mao de Obra")===(form._filtroTipo||"Todos");
                  return tipoOk&&(q===""||s.nome.toLowerCase().includes(q)||s.categoria?.toLowerCase().includes(q));
                }).map((s,i)=>{
                  const sel = form.servicosSolicitados.find(x=>x.nome===s.nome);
                  return (
                    <div key={i} onClick={()=>toggleServico(s.nome,s.preco,s.tipo,s.categoria)}
                      style={{alignItems:"center",background:sel?"var(--accent)22":"var(--bg2)",border:"1px solid "+(sel?"var(--accent)":"var(--border)"),borderRadius:8,cursor:"pointer",display:"flex",gap:8,justifyContent:"space-between",padding:"7px 10px"}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:12,fontWeight:sel?700:400,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.nome}</div>
                        <div style={{alignItems:"center",display:"flex",gap:4,marginTop:2}}>
                          <span style={{background:s.tipo==="Peca"?"#f59e0b22":"#6366f122",borderRadius:4,color:s.tipo==="Peca"?"#f59e0b":"#818cf8",fontSize:9,fontWeight:700,padding:"1px 5px"}}>{s.tipo==="Peca"?t("os.nova.filtro_peca"):t("os.nova.filtro_mao_obra")}</span>
                          {s.categoria&&<span style={{color:"var(--text3)",fontSize:9}}>{s.categoria}</span>}
                        </div>
                      </div>
                      <span style={{color:"var(--green)",fontSize:12,fontWeight:600,flexShrink:0}}>R$ {Number(s.preco).toFixed(2)}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,gridColumn:"1/-1",padding:16}}>
              <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,letterSpacing:"0.06em",marginBottom:12,textTransform:"uppercase"}}>{t("os.nova.obs_tecnicas")}</div>
              <textarea value={form.obs} onChange={e=>upd("obs",e.target.value)} placeholder={t("os.nova.obs_placeholder")} rows={2} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text)",fontFamily:"inherit",fontSize:13,outline:"none",padding:"10px 12px",resize:"vertical",width:"100%"}} />
            </div>
          </div>
          <div style={{alignItems:"center",display:"flex",gap:10,justifyContent:"flex-end",marginTop:20}}>
            <button onClick={()=>setModalNova(false)} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:13,padding:"10px 20px"}}>{t("os.nova.cancelar")}</button>
            <button onClick={criarOS} style={{background:"var(--accent)",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,padding:"10px 24px"}}>{t("os.nova.criar")}</button>
          </div>
        </Modal>
      )}

      {modalDetalhe && (
        <Modal onClose={()=>setModalDetalhe(null)} largura={700}>
          <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20,flexWrap:"wrap",rowGap:10}}>
            <div>
              <div style={{color:"var(--accent2)",fontFamily:"monospace",fontSize:12,marginBottom:4}}>{modalDetalhe.id}</div>
              {editandoOS ? (
                <input value={formEditOS.cliente} onChange={e=>setFormEditOS(f=>({...f,cliente:fmt("cliente",e.target.value)}))}
                  style={{background:"var(--bg2)",border:"1px solid var(--accent)",borderRadius:6,color:"var(--text)",fontSize:18,fontWeight:800,padding:"4px 8px"}} />
              ) : (
                <div style={{fontSize:18,fontWeight:800}}>{modalDetalhe.cliente}</div>
              )}
            </div>
            <div style={{display:"flex",gap:8,alignItems:"flex-start"}}>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {editandoOS ? (
                <>
                  <button onClick={cancelarEdicaoOS} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:12,padding:"8px 16px"}}>{t("common.cancelar")}</button>
                  <button onClick={salvarEdicaoOS} disabled={salvandoEdicaoOS} style={{background:"#22c55e",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 18px",opacity:salvandoEdicaoOS?0.7:1}}>{salvandoEdicaoOS?"Salvando...":"💾 Salvar"}</button>
                </>
              ) : (
                <>
                  <button onClick={()=>iniciarEdicaoOS(modalDetalhe)} style={{background:"#6366f122",border:"1px solid #6366f1",borderRadius:8,color:"#818cf8",cursor:"pointer",fontSize:12,fontWeight:600,padding:"8px 16px"}}>✏️ Editar</button>
                  <button onClick={()=>{setModalDetalhe(null);abrirOrcamento(modalDetalhe);}} style={{background:"var(--accent)22",border:"1px solid var(--accent)",borderRadius:8,color:"var(--accent)",cursor:"pointer",fontSize:12,fontWeight:600,padding:"8px 16px"}}>{t("os.detalhe.gerar_orcamento")}</button>
                  <button onClick={()=>setModalStatus(modalDetalhe)} style={{background:"#22c55e22",border:"1px solid #22c55e",borderRadius:8,color:"#22c55e",cursor:"pointer",fontSize:12,fontWeight:600,padding:"8px 16px"}}>{t("os.detalhe.avancar_status")}</button>
                  <button onClick={()=>abrirPagamentos(modalDetalhe)} style={{background:"#3b82f622",border:"1px solid #3b82f6",borderRadius:8,color:"#3b82f6",cursor:"pointer",fontSize:12,fontWeight:600,padding:"8px 16px"}}>{"\uD83D\uDCB3"} Pagamentos</button>
                  <button onClick={()=>excluirOS(modalDetalhe.id)} style={{background:"#ef444415",border:"1px solid #ef4444",borderRadius:8,color:"#ef4444",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>{t("os.detalhe.excluir")}</button>
                </>
              )}
              <button onClick={toggleHistoricoOS} style={{background:mostrarHistoricoOS?"var(--accent)22":"transparent",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:12,fontWeight:600,padding:"8px 16px"}}>{mostrarHistoricoOS?"Ocultar Historico":"Ver Historico"}</button>
            </div>
              <BtnFechar onClick={()=>setModalDetalhe(null)} />
            </div>
          </div>

          {/* COMPROVANTE DO SERVICO CONCLUIDO
              Aparece so quando a O.S. chegou a Concluido ou Entregue --
              mandar comprovante de servico que ainda esta em andamento seria
              informacao errada na mao do cliente.
              Fora durante a edicao: o que esta na tela nesse momento ainda
              nao foi gravado, e a mensagem sairia com dado que pode mudar.
              Previa, edicao do texto, modelo proprio da oficina e escolha de
              canal ficam dentro do painel (components/PainelWhatsApp.jsx). */}
          {!editandoOS && (modalDetalhe.status === "Concluido" || modalDetalhe.status === "Entregue") && (
            <PainelWhatsApp
              tipo="os_concluida"
              dados={payloadComprovante(modalDetalhe)}
              oficina={orcCfg}
              tenantId={tenantIdGlobal}
              chave={modalDetalhe.id}
              t={t}
            />
          )}

          {editandoOS ? (
            <div style={{display:"grid",gap:14,gridTemplateColumns:"1fr 1fr 1fr",marginBottom:16}}>
              {[["telefone","Telefone"],["cpf","CPF/CNPJ"],["veiculo","Veiculo"],["placa","Placa"],["km","KM"],["tecnico","Tecnico"]].map(([campo,label])=>(
                <div key={campo} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:12}}>
                  <div style={{color:"var(--text3)",fontSize:11,marginBottom:4}}>{label}</div>
                  <input value={formEditOS[campo]} onChange={e=>setFormEditOS(f=>({...f,[campo]:fmt(campo,e.target.value)}))}
                    maxLength={_LIMITE_CAMPO[campo]}
                    style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,fontWeight:600,padding:"6px 8px",width:"100%"}} />
                </div>
              ))}
            </div>
          ) : (
            <div style={{display:"grid",gap:14,gridTemplateColumns:"1fr 1fr 1fr",marginBottom:16}}>
              {[{l:tSeg("os.detalhe.veiculo"),v:modalDetalhe.veiculo},{l:t("os.detalhe.placa"),v:modalDetalhe.placa},{l:t("os.detalhe.km"),v:modalDetalhe.km||"-"},{l:t("os.detalhe.telefone"),v:modalDetalhe.telefone||"-"},{l:t("os.detalhe.tecnico"),v:modalDetalhe.tecnico||"-"},{l:t("os.detalhe.criada_em"),v:modalDetalhe.criada}].map(f=>(
                <div key={f.l} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:12}}>
                  <div style={{color:"var(--text3)",fontSize:11,marginBottom:4}}>{f.l}</div>
                  <div style={{fontSize:13,fontWeight:600}}>{f.v}</div>
                </div>
              ))}
            </div>
          )}

          <div style={{display:"grid",gap:14,gridTemplateColumns:"1fr 1fr",marginBottom:16}}>
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:12}}>
              <div style={{color:"var(--text3)",fontSize:11,marginBottom:6}}>{t("os.detalhe.relato_cliente")}</div>
              {editandoOS ? (
                <textarea value={formEditOS.relatoCliente||""} onChange={e=>setFormEditOS(f=>({...f,relatoCliente:e.target.value}))} rows={3}
                  style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontFamily:"inherit",fontSize:13,padding:"8px",resize:"vertical",width:"100%"}} />
              ) : (
                <div style={{fontSize:13,lineHeight:1.6}}>{modalDetalhe.relatoCliente||"-"}</div>
              )}
            </div>
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:12}}>
              <div style={{color:"var(--text3)",fontSize:11,marginBottom:6}}>{t("os.detalhe.obs_tecnicas")}</div>
              {editandoOS ? (
                <textarea value={formEditOS.obs} onChange={e=>setFormEditOS(f=>({...f,obs:e.target.value}))} rows={3}
                  style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontFamily:"inherit",fontSize:13,padding:"8px",resize:"vertical",width:"100%"}} />
              ) : (
                <div style={{fontSize:13,lineHeight:1.6}}>{modalDetalhe.obs||"-"}</div>
              )}
            </div>
          </div>
          <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:12}}>
            <div style={{color:"var(--text3)",fontSize:11,marginBottom:8}}>{t("os.detalhe.servicos_total")}</div>
            {itensDaOS(modalDetalhe).map((s,i)=>(
              <div key={i} style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:4}}>
                <span style={{fontSize:13}}>{s.nome}</span>
                <span style={{color:"var(--green)",fontSize:13,fontWeight:600}}>R$ {Number(s.preco).toFixed(2)}</span>
              </div>
            ))}
            <div style={{borderTop:"1px solid var(--border)",display:"flex",justifyContent:"space-between",marginTop:8,paddingTop:8}}>
              <span style={{fontWeight:700}}>{t("os.detalhe.total")}</span>
              <span style={{color:"var(--green)",fontWeight:800}}>R$ {(modalDetalhe.total||0).toFixed(2)}</span>
            </div>
          </div>
          {mostrarHistoricoOS && (
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:12,marginTop:12}}>
              <div style={{color:"var(--text3)",fontSize:11,marginBottom:8,fontWeight:700}}>Historico de Alteracoes</div>
              {carregandoHistoricoOS ? (
                <div style={{fontSize:12,color:"var(--text3)"}}>Carregando...</div>
              ) : historicoOS.length === 0 ? (
                <div style={{fontSize:12,color:"var(--text3)"}}>Nenhuma alteracao registrada.</div>
              ) : (
                historicoOS.map((h,i) => (
                  <div key={i} style={{borderBottom:i<historicoOS.length-1?"1px solid var(--border)":"none",padding:"6px 0",fontSize:12}}>
                    <div><b>{h.campo}</b>: {h.valorAnterior||"-"} {"->"} {h.valorNovo||"-"}</div>
                    <div style={{color:"var(--text3)",fontSize:11,marginTop:2}}>{h.usuario||"-"} em {h.em?new Date(h.em).toLocaleString("pt-BR"):"-"}</div>
                  </div>
                ))
              )}
            </div>
          )}
        </Modal>
      )}

      {modalOrcamento && (
        <Modal onClose={fecharOrcamento} largura={modalOrcamento.step===2?900:1100}>
          {/* AUD-G -- estado da gravacao, sempre no topo do modal. */}
          {orcAviso && (
            <div style={{alignItems:"center",background:orcAviso.tipo==="erro"?"#ef444422":"#22c55e22",border:"1px solid "+(orcAviso.tipo==="erro"?"#ef4444":"#22c55e"),borderRadius:8,color:orcAviso.tipo==="erro"?"#fca5a5":"#86efac",display:"flex",fontSize:12.5,gap:10,justifyContent:"space-between",marginBottom:12,padding:"9px 12px"}}>
              <span>{orcAviso.texto}</span>
              <button onClick={()=>setOrcAviso(null)} style={{background:"transparent",border:"none",color:"inherit",cursor:"pointer",fontSize:14,lineHeight:1,padding:0}}>x</button>
            </div>
          )}
          {confirmandoFecharOrc && (
            <div style={{background:"#f59e0b22",border:"1px solid #f59e0b",borderRadius:8,marginBottom:12,padding:"10px 12px"}}>
              <div style={{color:"#fcd34d",fontSize:12.5,fontWeight:700,marginBottom:9}}>{t("os.orc.fechar_sem_salvar", "Este orcamento tem alteracoes que ainda nao foram gravadas.")}</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                <button disabled={orcSalvando} onClick={()=>{confirmarOrcamento(false).then((ok)=>{ if (ok) { setConfirmandoFecharOrc(false); setOrcAviso(null); setModalOrcamento(null); } });}}
                  style={{background:"#16a34a",border:"none",borderRadius:6,color:"#fff",cursor:orcSalvando?"wait":"pointer",fontSize:12,fontWeight:700,opacity:orcSalvando?0.6:1,padding:"6px 12px"}}>
                  {orcSalvando ? t("os.orc.salvando", "Salvando...") : t("os.orc.salvar_e_fechar", "Salvar e fechar")}
                </button>
                <button onClick={()=>{setConfirmandoFecharOrc(false);setOrcAviso(null);setModalOrcamento(null);}}
                  style={{background:"transparent",border:"1px solid #ef4444",borderRadius:6,color:"#fca5a5",cursor:"pointer",fontSize:12,padding:"6px 12px"}}>
                  {t("os.orc.descartar_e_fechar", "Descartar e fechar")}
                </button>
                <button onClick={()=>setConfirmandoFecharOrc(false)}
                  style={{background:"transparent",border:"1px solid var(--border)",borderRadius:6,color:"var(--text2)",cursor:"pointer",fontSize:12,padding:"6px 12px"}}>
                  {t("os.orc.continuar_editando", "Continuar editando")}
                </button>
              </div>
            </div>
          )}
          <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:16}}>
            <div>
              <div style={{color:"var(--accent2)",fontSize:12,marginBottom:4}}>{modalOrcamento.step===1?t("os.orc.label_orcamento"):t("os.orc.label_previsualizacao")}</div>
              <div style={{fontSize:18,fontWeight:800}}>{modalOrcamento.os.id} - {modalOrcamento.os.cliente}</div>
            </div>
            <div style={{display:"flex",gap:8}}>
              {modalOrcamento.step===1 && (<div style={{display:"flex",flexDirection:"column",gap:8,width:"100%"}}>
  {painelFotos && (
    <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16,marginBottom:4}}>
      <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:10}}>
        <div style={{color:"var(--text2)",fontSize:12,fontWeight:700}}>{t("os.orc.fotos_titulo",{count:fotasPremium.length})}</div>
        <button onClick={()=>setPainelFotos(false)} style={{background:"none",border:"none",color:"var(--text3)",cursor:"pointer",fontSize:16}}>x</button>
      </div>
      <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center"}}>
        <label style={{background:"var(--accent)",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",display:"inline-block",fontSize:12,fontWeight:700,padding:"8px 16px"}}>
          {t("os.orc.add_foto")}
          <input type="file" accept="image/*" multiple style={{display:"none"}} onChange={e=>{Array.from(e.target.files).forEach(f=>{if(f.size>5*1024*1024)return;const r=new FileReader();r.onloadend=()=>setFotasPremium(prev=>[...prev,{url:r.result,descricao:""}]);r.readAsDataURL(f);});}}/>
        </label>
        {fotasPremium.length>0&&<button onClick={()=>{const osId=(modalOrcamento&&modalOrcamento.os&&modalOrcamento.os.id)||"tmp";try{localStorage.setItem("fotos_orcamento_"+osId,JSON.stringify(fotasPremium));}catch(e){}alert(t("os.alertas.fotos_salvas"));}} style={{background:"#22c55e",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 16px"}}>{t("os.orc.salvar_fotos")}</button>}
        {fotasPremium.length>0&&<span style={{color:"var(--text3)",fontSize:11}}>{fotasPremium.length} foto{fotasPremium.length>1?"s":""}</span>}
      </div>
      {fotasPremium.length>0&&(<div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))"}}>
        {fotasPremium.map((foto,i)=>(<div key={i} style={{background:"var(--bg2)",borderRadius:8,overflow:"hidden",border:"1px solid var(--border)"}}>
          <img src={foto.url||foto} alt={"Foto "+(i+1)} style={{height:100,objectFit:"cover",width:"100%"}} />
          <div style={{padding:"6px 8px"}}>
            <input value={foto.descricao||""} onChange={e=>setFotasPremium(prev=>prev.map((f,j)=>j===i?{...f,descricao:e.target.value}:f))} placeholder={t("os.orc.foto_desc_placeholder")} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:4,color:"var(--text)",fontSize:11,padding:"3px 6px",width:"100%"}} />
            <button onClick={()=>setFotasPremium(prev=>prev.filter((_,j)=>j!==i))} style={{background:"#ef444422",border:"1px solid #ef4444",borderRadius:4,color:"#ef4444",cursor:"pointer",fontSize:10,marginTop:4,padding:"2px 8px",width:"100%"}}>{t("os.orc.remover")}</button>
          </div>
        </div>))}
      </div>)}
    </div>
  )}
  <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:10}}>
    <label style={{color:"var(--text2)",fontSize:12,fontWeight:600}}>Data e hora do orcamento:</label>
    <input type="datetime-local" value={isoToLocalInput(modalOrcamento.dataHora)} onChange={(e)=>setModalOrcamento(m=>({...m,dataHora:e.target.value?new Date(e.target.value).toISOString():new Date().toISOString()}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text)",fontSize:12,padding:"6px 10px"}} />
  </div>
  <div style={{display:"flex",gap:8,alignItems:"center"}}>
    <button onClick={()=>setPainelFotos(p=>!p)} style={{background:painelFotos?"var(--accent)":"var(--bg3)",border:"1px solid "+(painelFotos?"var(--accent)":"var(--border)"),borderRadius:8,color:painelFotos?"#fff":"var(--text2)",cursor:"pointer",fontSize:12,fontWeight:600,padding:"8px 14px"}}>
      📷 {t("os.orc.fotos_btn")}{fotasPremium.length>0?" ("+fotasPremium.length+")":""}
    </button>
    {/* AUD-G -- o dono precisa ver, sem perguntar a ninguem, se ja gravou. */}
    <span style={{alignItems:"center",background:orcSujo?"#f59e0b22":"#22c55e18",border:"1px solid "+(orcSujo?"#f59e0b":"#22c55e55"),borderRadius:6,color:orcSujo?"#fcd34d":"#86efac",display:"flex",fontSize:10.5,fontWeight:700,letterSpacing:"0.03em",padding:"5px 9px",textTransform:"uppercase",whiteSpace:"nowrap"}}>
      {orcSujo ? t("os.orc.nao_salvo", "alteracoes nao salvas") : t("os.orc.tudo_salvo", "tudo salvo")}
    </span>
    <button disabled={orcSalvando || !orcSujo} onClick={()=>confirmarOrcamento(false)}
      style={{background:orcSujo?"var(--accent)":"var(--bg3)",border:"1px solid "+(orcSujo?"var(--accent)":"var(--border)"),borderRadius:8,color:orcSujo?"#fff":"var(--text3)",cursor:(orcSalvando||!orcSujo)?"default":"pointer",fontSize:12,fontWeight:700,padding:"8px 14px",whiteSpace:"nowrap"}}>
      {orcSalvando ? t("os.orc.salvando", "Salvando...") : t("os.orc.salvar", "Salvar")}
    </button>
    <button className="btn-primary" style={{background:"#16a34a",fontSize:12}} onClick={()=>confirmarOrcamento(true)}>{t("os.orc.ver_previsualizacao")}</button>
  </div>
</div>)}
              {modalOrcamento.step===2 && (
                <>
                  <button onClick={()=>setModalOrcamento(m=>({...m,step:1}))} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>{t("os.orc.editar")}</button>
                  <button className="btn-primary" style={{background:"#16a34a",fontSize:12}} onClick={()=>setModalImpressao(true)}>{t("os.orc.imprimir_pdf")}</button>
                </>
              )}
              <BtnFechar onClick={fecharOrcamento} />
            </div>
          </div>

          {modalOrcamento.step===1 && (
            <div style={{display:"grid",gap:16,gridTemplateColumns:"1fr 1fr"}}>
              <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
                <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,marginBottom:10,textTransform:"uppercase"}}>{t("os.orc.catalogo_servicos")}</div>
                <div style={{alignItems:"center",background:"var(--bg2)",border:"1px dashed var(--accent)",borderRadius:8,display:"flex",gap:8,marginBottom:10,padding:"8px 10px"}}>
                  <input placeholder={t("os.orc.item_personalizado_placeholder")} style={{background:"transparent",border:"none",flex:1,fontSize:13,outline:"none"}} id="orc-nome" />
                  <input type="text" placeholder={t("os.orc.custo_placeholder", "custo")} title={t("os.orc.custo_title", "Custo da peca -- opcional, so para a conta interna de ganho. Nao aparece no documento do cliente.")} style={{background:"transparent",border:"none",color:"var(--text2)",fontSize:12,outline:"none",textAlign:"right",width:56}} id="orc-custo" />
                  <input type="text" placeholder="0,00" style={{background:"transparent",border:"none",fontSize:13,outline:"none",textAlign:"right",width:70}} id="orc-preco" />
                  <button onClick={()=>{const nome=document.getElementById("orc-nome").value.trim();const preco=parseFloat(document.getElementById("orc-preco").value)||0;const custo=parseFloat(document.getElementById("orc-custo").value)||0;if(!nome)return;addItemOrc({nome,preco,custo});document.getElementById("orc-nome").value="";document.getElementById("orc-preco").value="";document.getElementById("orc-custo").value="";}} style={{background:"var(--accent)",border:"none",borderRadius:6,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"5px 12px",whiteSpace:"nowrap"}}>{t("os.orc.add")}</button>
                </div>
                <div style={{...rolo(300),display:"flex",flexDirection:"column",gap:6}}>
                  {catalogoCompleto().map((item,i)=>{
                    const sel=modalOrcamento.itens.find(x=>x.nome===item.nome);
                    return (
                      <div key={i} style={{alignItems:"center",background:sel?"var(--accent)22":"var(--bg2)",border:"1px solid "+(sel?"var(--accent)":"var(--border)"),borderRadius:8,display:"flex",justifyContent:"space-between",padding:"8px 12px",gap:8}}>
                        <div style={{flex:1,minWidth:0}}><div style={{fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.nome}</div></div>
                        <input type="number" min="0" step="0.01" defaultValue={Number(item.preco).toFixed(2)} onBlur={e=>{const novoPreco=parseFloat(e.target.value)||item.preco; item.preco=novoPreco; item.precoUnit=novoPreco;}} onClick={e=>e.stopPropagation()} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:6,color:"#16a34a",fontSize:12,fontWeight:700,padding:"3px 6px",textAlign:"right",width:80}} />
                        <button onClick={()=>sel?removeItemOrc(item.nome):addItemOrc(item)} style={{background:sel?"#ef444422":"var(--accent)22",border:"1px solid "+(sel?"#ef4444":"var(--accent)"),borderRadius:6,color:sel?"#ef4444":"var(--accent)",cursor:"pointer",fontSize:18,lineHeight:1,padding:"2px 8px"}}>{sel?"-":"+"}</button>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
                <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,marginBottom:10,textTransform:"uppercase"}}>{t("os.orc.selecionados",{count:modalOrcamento.itens.length})}</div>
                {/* Rolo: a lista rola por dentro e o Total abaixo nunca sai
                    da vista, por mais itens que o orcamento tenha. */}
                <div style={rolo(320)}>
                {modalOrcamento.itens.map((item,i)=>(
                  <div key={i} style={{alignItems:"center",background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,display:"flex",gap:8,justifyContent:"space-between",marginBottom:8,padding:"8px 12px"}}>
                    <div style={{flex:1}}>
                      <div style={{alignItems:"center",display:"flex",gap:6}}>
                        {/* Nome editavel no lugar. Parece texto: fundo e
                            borda transparentes, mesma tipografia do <span>
                            que estava aqui. Ganha moldura ao passar o mouse
                            e ao focar, para ficar claro que da para corrigir
                            sem excluir o item e perder a posicao na lista.
                            Enter confirma, Esc desfaz, campo vazio volta ao
                            nome anterior -- nome em branco imprimiria linha
                            vazia no documento do cliente. */}
                        <input type="text" value={item.nome ?? ""}
                          onChange={e=>updateNomeItemOrc(i, e.target.value)}
                          onFocus={e=>{e.target.dataset.antes = item.nome ?? ""; e.target.style.background="var(--bg2)"; e.target.style.borderColor="var(--accent)";}}
                          onBlur={e=>{e.target.style.background="transparent"; e.target.style.borderColor="transparent"; const limpo=(e.target.value||"").trim(); updateNomeItemOrc(i, limpo || e.target.dataset.antes || "");}}
                          onKeyDown={e=>{if(e.key==="Enter"){e.preventDefault();e.target.blur();}else if(e.key==="Escape"){e.preventDefault();e.target.value=e.target.dataset.antes||"";e.target.blur();}}}
                          onMouseEnter={e=>{if(document.activeElement!==e.target)e.target.style.borderColor="var(--border)";}}
                          onMouseLeave={e=>{if(document.activeElement!==e.target)e.target.style.borderColor="transparent";}}
                          title={t("os.orc.nome_item_title", "Corrija o nome aqui mesmo -- o item mantem a posicao na lista.")}
                          style={{background:"transparent",border:"1px solid transparent",borderRadius:5,color:"var(--text)",flex:1,fontFamily:"inherit",fontSize:13,fontWeight:600,minWidth:0,outline:"none",padding:"2px 5px"}} />
                        {item.origem==="estoque_interno" && <span style={{background:"#3b82f622",borderRadius:4,color:"#60a5fa",fontSize:9,fontWeight:700,padding:"1px 5px",textTransform:"uppercase"}}>{t("os.orc.origem_estoque")}</span>}
                        {item.origem==="compra_fornecedor" && <span style={{background:"#f9731622",borderRadius:4,color:"#fb923c",fontSize:9,fontWeight:700,padding:"1px 5px",textTransform:"uppercase"}}>{t("os.orc.origem_fornecedor")}</span>}
                      </div>
                      {/* Valores editaveis. Custo e venda por unidade; o
                          verde a direita e o total da linha, recalculado. */}
                      <div style={{alignItems:"center",display:"flex",flexWrap:"wrap",gap:6,marginTop:4}}>
                        <span style={{color:"var(--text3)",fontSize:9.5,textTransform:"uppercase"}}>{t("os.orc.custo_label", "Custo")}</span>
                        <input type="number" min="0" step="0.01" value={item.custoUnit ?? ""} placeholder="0,00"
                          onChange={e=>updateCustoUnitOrc(i, e.target.value)}
                          title={t("os.orc.custo_title", "Custo da peca -- opcional, so para a conta interna de ganho. Nao aparece no documento do cliente.")}
                          style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:5,color:"var(--text2)",fontSize:11.5,padding:"3px 6px",textAlign:"right",width:66}} />
                        <span style={{color:"var(--text3)",fontSize:9.5,textTransform:"uppercase"}}>{t("os.orc.venda_label", "Venda")}</span>
                        <input type="number" min="0" step="0.01" value={item.precoUnit ?? item.preco ?? ""} placeholder="0,00"
                          onChange={e=>updatePrecoUnitOrc(i, e.target.value)}
                          style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:5,color:"var(--text)",fontSize:11.5,padding:"3px 6px",textAlign:"right",width:72}} />
                        <span style={{color:"#16a34a",fontSize:12,fontWeight:700}}>= R$ {Number(item.preco).toFixed(2)}</span>
                      </div>
                    </div>
                    <input type="number" min="1" value={item.qtd??1} onChange={e=>updateQtdOrc(i,e.target.value)} style={{textAlign:"center",width:50}} />
                    <button onClick={()=>removeItemOrcIndice(i)} style={{background:"#ef444422",border:"1px solid #ef4444",borderRadius:6,color:"#ef4444",cursor:"pointer",fontSize:14,padding:"3px 8px"}}>x</button>
                  </div>
                ))}
                </div>
                <div style={{borderTop:"1px solid var(--border)",marginTop:12,paddingTop:12}}>
                  <div style={{color:(orcCfg?.corDocumento)||"#1e40af",fontSize:20,fontWeight:800}}>{t("os.detalhe.total")}: R$ {modalOrcamento.itens.reduce((a,s)=>a+(Number(s.preco)||0),0).toFixed(2)}</div>
                  {/* Faixa INTERNA da oficina: custo, ganho e percentual.
                      Fica so na tela de montagem -- nao existe em nenhum dos
                      tres modelos de documento, que imprimem apenas nome,
                      quantidade e valor. O cliente nunca ve isto. */}
                  {(() => {
                    const _t = totaisDoOrcamento(modalOrcamento.itens);
                    if (!_t.temAlgumCusto) return null;
                    const _bom = _t.ganho >= 0;
                    return (
                      <div style={{background:"var(--bg2)",border:"1px dashed var(--border2, var(--border))",borderRadius:8,marginTop:12,padding:"10px 12px"}}>
                        <div style={{alignItems:"center",display:"flex",gap:6,marginBottom:8}}>
                          <span style={{background:"#64748b22",borderRadius:4,color:"var(--text3)",fontSize:9,fontWeight:700,letterSpacing:"0.08em",padding:"2px 6px",textTransform:"uppercase"}}>{t("os.orc.interno", "Interno da oficina")}</span>
                          <span style={{color:"var(--text3)",fontSize:10}}>{t("os.orc.interno_hint", "nao aparece no documento do cliente")}</span>
                        </div>
                        <div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(3,1fr)"}}>
                          <div>
                            <div style={{color:"var(--text3)",fontSize:10,textTransform:"uppercase"}}>{t("os.orc.custo_label", "Custo")}</div>
                            <div style={{fontSize:14,fontWeight:700}}>{emReais(_t.custo)}</div>
                          </div>
                          <div>
                            <div style={{color:"var(--text3)",fontSize:10,textTransform:"uppercase"}}>{t("os.orc.repassado_label", "Repassado")}</div>
                            <div style={{fontSize:14,fontWeight:700}}>{emReais(_t.vendaComCusto)}</div>
                          </div>
                          <div>
                            <div style={{color:"var(--text3)",fontSize:10,textTransform:"uppercase"}}>{t("os.orc.ganho_label", "Ganho")}</div>
                            <div style={{color:_bom?"#22c55e":"#ef4444",fontSize:14,fontWeight:800}}>
                              {emReais(_t.ganho)} <span style={{fontSize:11,fontWeight:600}}>({_t.margem.toFixed(1)}%)</span>
                            </div>
                          </div>
                        </div>
                        {_t.itensSemCusto > 0 && (
                          <div style={{color:"var(--text3)",fontSize:10.5,marginTop:8}}>
                            {t("os.orc.margem_parcial", "A conta acima considera as pecas com custo informado.")} {_t.itensComCusto}/{_t.itensComCusto + _t.itensSemCusto}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          )}

          {/* Fase 2 -- origem da peca (Estoque interno / Compra em fornecedor).
              Bloco aditivo, abaixo do grid existente -- nao altera nada do
              Catalogo de Servicos nem da lista "Selecionados" acima. */}
          {modalOrcamento.step===1 && (
            <div style={{display:"grid",gap:16,gridTemplateColumns:"1fr 1fr",marginTop:16}}>
              <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
                <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,marginBottom:10,textTransform:"uppercase"}}>{t("os.orc.peca_estoque")}</div>
                {estoqueItens.length===0 ? (
                  <div style={{color:"var(--text3)",fontSize:12,padding:"10px 0",textAlign:"center"}}>{t("os.orc.nenhum_no_estoque")}</div>
                ) : (
                  <div style={{...rolo(220),display:"flex",flexDirection:"column",gap:6}}>
                    {estoqueItens.map((it) => {
                      const sel = modalOrcamento.itens.find(i=>i.estoqueId===it.id);
                      const semEstoque = Number(it.quantidade)<=0;
                      return (
                        <div key={it.id} style={{alignItems:"center",background:sel?"var(--accent)22":"var(--bg2)",border:"1px solid "+(sel?"var(--accent)":"var(--border)"),borderRadius:8,display:"flex",gap:8,justifyContent:"space-between",padding:"8px 12px"}}>
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{it.nome}</div>
                            <div style={{color:semEstoque?"#ef4444":"var(--text3)",fontSize:11}}>{semEstoque?t("os.orc.sem_estoque"):t("os.orc.disponivel",{qtd:it.quantidade,unidade:it.unidade||"un"})} · R$ {Number(it.preco).toFixed(2)}</div>
                          </div>
                          <button disabled={!sel && semEstoque} onClick={()=>sel?removeItemOrc(it.nome):addItemEstoque(it)}
                            style={{background:sel?"#ef444422":semEstoque?"var(--bg4)":"var(--accent)22",border:"1px solid "+(sel?"#ef4444":semEstoque?"var(--border)":"var(--accent)"),borderRadius:6,color:sel?"#ef4444":semEstoque?"var(--text3)":"var(--accent)",cursor:(!sel&&semEstoque)?"not-allowed":"pointer",fontSize:18,lineHeight:1,padding:"2px 8px"}}>
                            {sel?"-":"+"}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
                <div style={{color:"var(--text2)",fontSize:11,fontWeight:700,marginBottom:10,textTransform:"uppercase"}}>{t("os.orc.peca_compra_externa")}</div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  <input placeholder={t("os.orc.nome_peca_placeholder")} value={formFornecedor.nome} onChange={e=>setFormFornecedor(f=>({...f,nome:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:12,padding:"6px 10px"}} />
                  <input placeholder={t("os.orc.fornecedor_placeholder")} value={formFornecedor.fornecedor} onChange={e=>setFormFornecedor(f=>({...f,fornecedor:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:12,padding:"6px 10px"}} />
                  <div style={{display:"grid",gap:6,gridTemplateColumns:"1fr 1fr 1fr"}}>
                    <input placeholder={t("os.orc.custo_unit_placeholder")} type="number" value={formFornecedor.custo} onChange={e=>setFormFornecedor(f=>({...f,custo:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:12,padding:"6px 8px"}} />
                    <input placeholder={t("os.orc.venda_unit_placeholder")} type="number" value={formFornecedor.preco} onChange={e=>setFormFornecedor(f=>({...f,preco:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:12,padding:"6px 8px"}} />
                    <input placeholder={t("os.orc.qtd_placeholder")} type="number" value={formFornecedor.qtd} onChange={e=>setFormFornecedor(f=>({...f,qtd:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:12,padding:"6px 8px"}} />
                  </div>
                  <button onClick={addItemFornecedor} style={{background:"var(--accent)",border:"none",borderRadius:6,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"7px 12px"}}>{t("os.orc.adicionar_ao_orcamento")}</button>
                </div>
              </div>
            </div>
          )}

          {modalOrcamento.step===2 && (
            <>
              {(planoAtual==="premium"||_featuresLiberadas.includes("orcamento_profissional")||_featuresLiberadas.includes("orcamento_premium")) && (
                <div style={{display:"flex",gap:8,marginBottom:12}}>
                  <div style={{color:"var(--text3)",fontSize:11,fontWeight:700,marginRight:4,alignSelf:"center"}}>{t("os.orc.modelo_label")}</div>
                  {["basico",...((planoAtual==="premium"||_featuresLiberadas.includes("orcamento_profissional"))?["profissional"]:[]),...((planoAtual==="premium"||_featuresLiberadas.includes("orcamento_premium"))?["premium"]:[])].map(m=>(
                    <button key={m} onClick={()=>setModeloOrc(m)}
                      style={{background:modeloOrc===m?"var(--accent)":"var(--bg3)",border:"1px solid "+(modeloOrc===m?"var(--accent)":"var(--border)"),borderRadius:6,color:modeloOrc===m?"#fff":"var(--text2)",cursor:"pointer",fontSize:11,fontWeight:600,padding:"4px 12px",textTransform:"capitalize"}}>
                      {t("os.orc.modelo_"+m)}
                    </button>
                  ))}
                </div>
              )}
              <div id="print-doc" style={{...getFundoStyle(),borderRadius:12,color:"#1e293b",fontFamily:"Arial, sans-serif",padding:0,overflow:"hidden",position:"relative"}}>
              {modeloOrc==="basico" && (<div style={{padding:32}}><div style={{alignItems:"flex-start",borderBottom:"2px solid #e2e8f0",display:"flex",justifyContent:"space-between",marginBottom:24,paddingBottom:20}}><div>{orcCfg?.logoUrl&&<img src={orcCfg.logoUrl} alt="logo" style={{height:90,marginBottom:10,objectFit:"contain",display:"block",background:"none",border:"none",boxShadow:"none"}} />}<div style={{color:(orcCfg?.corDocumento)||"#1e40af",fontSize:22,fontWeight:800}}>{orcCfg?.nomeEmpresa||config.nome||"SAAS.GL"}</div>{orcCfg?.telefone&&<div style={{color:"#64748b",fontSize:12,marginTop:2}}>{t("os.orc.doc.tel_prefix")} {orcCfg.telefone}</div>}{orcCfg?.endereco&&<div style={{color:"#64748b",fontSize:12}}>{orcCfg.endereco}</div>}{orcCfg?.documento&&<div style={{color:"#64748b",fontSize:12}}>CNPJ/CPF: {orcCfg.documento}</div>}{orcCfg?.email&&<div style={{color:"#64748b",fontSize:12}}>{orcCfg.email}</div>}</div><div style={{textAlign:"right"}}><div style={{background:(orcCfg?.corDocumento)||"#1e40af",borderRadius:8,color:"#fff",fontSize:13,fontWeight:700,padding:"4px 14px"}}>{rotuloDocOS}</div><div style={{color:"#64748b",fontSize:12,marginTop:6}}>{t("os.orc.doc.data_prefix")} {fmtDataHoraOrc(modalOrcamento.dataHora)}</div><div style={{color:"#64748b",fontSize:12}}>{t("os.orc.doc.ref_prefix")} {modalOrcamento.os.id}</div></div></div><div style={{display:"grid",gap:16,gridTemplateColumns:"1fr 1fr",marginBottom:24}}><div style={{background:"#f8fafc",borderRadius:8,padding:14}}><div style={{color:"#64748b",fontSize:11,fontWeight:700,marginBottom:6,textTransform:"uppercase"}}>{t("os.orc.doc.cliente")}</div><div style={{fontSize:14,fontWeight:700}}>{modalOrcamento.os.cliente}</div>{modalOrcamento.os.telefone&&<div style={{color:"#64748b",fontSize:12,marginTop:4}}>{t("os.orc.doc.tel_prefix")} {modalOrcamento.os.telefone}</div>}</div><div style={{background:"#f8fafc",borderRadius:8,padding:14}}><div style={{color:"#64748b",fontSize:11,fontWeight:700,marginBottom:6,textTransform:"uppercase"}}>{tSeg("os.orc.doc.veiculo")}</div><div style={{fontSize:14,fontWeight:700}}>{modalOrcamento.os.veiculo}</div><div style={{color:(orcCfg?.corDocumento)||"#1e40af",fontFamily:"monospace",fontSize:16,fontWeight:900,marginTop:4}}>{modalOrcamento.os.placa}</div></div></div><table style={{borderCollapse:"collapse",marginBottom:18,width:"100%"}}><thead><tr style={{background:(orcCfg?.corDocumento)||"#1e40af",color:"#fff"}}>{[t("os.orc.doc.col_descricao"),t("os.orc.doc.col_qtd"),t("os.orc.doc.col_valor_unit"),t("os.orc.doc.col_total")].map((h,i)=>(<th key={h} style={{fontSize:12,padding:"10px 14px",textAlign:i===0?"left":i===1?"center":"right"}}>{h}</th>))}</tr></thead><tbody>{modalOrcamento.itens.map((item,i)=>(<tr key={i} style={{background:i%2===0?"#f8fafc":"#fff"}}><td style={{borderBottom:"1px solid #e2e8f0",fontSize:13,padding:"9px 14px"}}>{item.nome}</td><td style={{borderBottom:"1px solid #e2e8f0",fontSize:13,padding:"9px 14px",textAlign:"center"}}>{item.qtd||1}</td><td style={{borderBottom:"1px solid #e2e8f0",fontSize:13,padding:"9px 14px",textAlign:"right"}}>R$ {(Number(item.preco)/(item.qtd||1)).toFixed(2)}</td><td style={{borderBottom:"1px solid #e2e8f0",fontSize:13,fontWeight:600,padding:"9px 14px",textAlign:"right"}}>R$ {Number(item.preco).toFixed(2)}</td></tr>))}</tbody></table><div style={{display:"flex",justifyContent:"flex-end",marginBottom:20}}><div style={{background:"#f8fafc",borderRadius:8,minWidth:220,padding:14}}><div style={{alignItems:"center",borderTop:"2px solid #e2e8f0",display:"flex",justifyContent:"space-between",paddingTop:10}}><span style={{fontSize:14,fontWeight:700}}>{t("os.orc.doc.total_label")}</span><span style={{color:(orcCfg?.corDocumento)||"#1e40af",fontSize:18,fontWeight:800}}>R$ {modalOrcamento.itens.reduce((a,i)=>a+(Number(i.preco)||0),0).toFixed(2)}</span></div></div></div><div style={{background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:8,marginBottom:24,padding:14}}><div style={{color:"#16a34a",fontSize:11,fontWeight:700,marginBottom:6,textTransform:"uppercase"}}>{t("os.orc.doc.politica_label")}</div><div style={{color:"#374151",fontSize:12,lineHeight:1.7}}>{(orcCfg?.tipos&&orcCfg.tipos[0]?.politica)||t("os.orc.doc.politica_default")}</div></div>{fotasPremium.length > 0 && (<div style={{marginBottom:20}}><div style={{color:"#64748b",fontSize:11,fontWeight:700,letterSpacing:"0.08em",marginBottom:10,textTransform:"uppercase"}}>{t("os.orc.doc.registro_fotografico")}</div><div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(3,1fr)"}}>{fotasPremium.map((foto,i)=>(<div key={i} style={{borderRadius:8,overflow:"hidden",border:"1px solid #e2e8f0"}}><img src={foto.url||foto} alt={t("os.orc.doc.foto_alt")+" "+(i+1)} style={{height:110,objectFit:"cover",width:"100%"}} />{(foto.descricao)&&<div style={{background:"#f8fafc",color:"#374151",fontSize:11,fontWeight:600,padding:"4px 8px",textAlign:"center",borderTop:"1px solid #e2e8f0"}}>{foto.descricao}</div>}</div>))}</div></div>)}<div style={{borderTop:"2px solid #e2e8f0",display:"grid",gap:32,gridTemplateColumns:"1fr 1fr",paddingTop:24}}><div style={{textAlign:"center"}}><div style={{borderTop:"1px solid #94a3b8",color:"#64748b",fontSize:12,paddingTop:8}}>{t("os.orc.doc.assinatura_responsavel")}</div></div><div style={{textAlign:"center"}}><div style={{borderTop:"1px solid #94a3b8",color:"#64748b",fontSize:12,paddingTop:8}}>{t("os.orc.doc.assinatura_cliente")}</div></div></div></div>)}
              {modeloOrc==="profissional" && (<div><div style={{background:"linear-gradient(135deg,"+corSegura()+","+corEscura(0.18)+")",padding:"28px 32px",color:"#fff"}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div>{orcCfg?.logoUrl&&<img src={orcCfg.logoUrl} alt="logo" style={{height:90,marginBottom:10,objectFit:"contain",display:"block",background:"none",border:"none",boxShadow:"none"}} />}<div style={{fontSize:24,fontWeight:900}}>{orcCfg?.nomeEmpresa||config.nome||"SAAS.GL"}</div>{orcCfg?.telefone&&<div style={{fontSize:12,marginTop:4,opacity:0.85}}>{t("os.orc.doc.tel_prefix")} {orcCfg.telefone}</div>}{orcCfg?.endereco&&<div style={{fontSize:12,opacity:0.85}}>{orcCfg.endereco}</div>}{orcCfg?.documento&&<div style={{fontSize:12,opacity:0.85}}>CNPJ/CPF: {orcCfg.documento}</div>}{orcCfg?.email&&<div style={{fontSize:12,opacity:0.85}}>{orcCfg.email}</div>}<div style={{fontSize:11,marginTop:2,opacity:0.7}}>{rotuloDocOS}</div></div><div style={{textAlign:"right"}}><div style={{fontSize:11,opacity:0.85}}>{t("os.orc.doc.num_prefix")} {modalOrcamento.os.id}</div><div style={{fontSize:11,opacity:0.85}}>{t("os.orc.doc.data_prefix")} {fmtDataHoraOrc(modalOrcamento.dataHora)}</div></div></div></div><div style={{padding:28,background:"rgba(255,255,255,0.92)"}}><div style={{display:"grid",gap:12,gridTemplateColumns:"repeat(4,1fr)",marginBottom:20}}>{[{t:t("os.orc.doc.cliente"),v:modalOrcamento.os.cliente,s:modalOrcamento.os.telefone?t("os.orc.doc.tel_prefix")+" "+modalOrcamento.os.telefone:""},{t:tSeg("os.orc.doc.veiculo"),v:modalOrcamento.os.veiculo,s:modalOrcamento.os.placa},{t:t("os.orc.doc.km"),v:modalOrcamento.os.km||"—",s:""},{t:t("os.col_tecnico"),v:modalOrcamento.os.tecnico||"—",s:""}].map((f,i)=>(<div key={i} style={{background:corAlfa(0.07),border:"1px solid "+corAlfa(0.28),borderRadius:10,padding:12}}><div style={{color:corSegura(),fontSize:10,fontWeight:700,marginBottom:3,textTransform:"uppercase"}}>{f.t}</div><div style={{fontSize:13,fontWeight:700,color:"#1e293b"}}>{f.v}</div>{f.s&&<div style={{color:corSegura(),fontSize:11,marginTop:2}}>{f.s}</div>}</div>))}</div><div style={{background:corAlfa(0.07),border:"1px solid "+corAlfa(0.28),borderRadius:8,fontSize:12,lineHeight:1.8,marginBottom:18,padding:14,color:"#1e3a5f"}}><div style={{fontWeight:700,marginBottom:4,color:corSegura()}}>{t("os.orc.doc.diagnostico_tecnico")}</div>{modalOrcamento.os.relatoCliente||tSeg("os.orc.doc.diagnostico_default")}</div><div style={{background:corSegura(),borderRadius:"8px 8px 0 0",color:"#fff",display:"grid",fontSize:11,fontWeight:700,gridTemplateColumns:"1fr auto auto auto",padding:"10px 14px",textTransform:"uppercase"}}><span>{t("os.orc.doc.col_servico")}</span><span style={{textAlign:"center",minWidth:50}}>{t("os.orc.doc.col_qtd")}</span><span style={{textAlign:"right",minWidth:80}}>{t("os.orc.doc.col_unit")}</span><span style={{textAlign:"right",minWidth:80}}>{t("os.orc.doc.col_total")}</span></div>{modalOrcamento.itens.map((item,i)=>(<div key={i} style={{background:i%2===0?corAlfa(0.05):"#fff",borderLeft:"1px solid "+corAlfa(0.28),borderRight:"1px solid "+corAlfa(0.28),borderBottom:"1px solid "+corAlfa(0.28),display:"grid",fontSize:13,gridTemplateColumns:"1fr auto auto auto",padding:"10px 14px",alignItems:"center"}}><span style={{fontWeight:500}}>{item.nome}</span><span style={{textAlign:"center",minWidth:50,color:"#64748b"}}>{item.qtd||1}</span><span style={{textAlign:"right",minWidth:80,color:"#64748b"}}>R$ {(Number(item.preco)/(item.qtd||1)).toFixed(2)}</span><span style={{textAlign:"right",minWidth:80,fontWeight:700,color:corSegura()}}>R$ {Number(item.preco).toFixed(2)}</span></div>))}<div style={{background:corSegura(),borderRadius:"0 0 8px 8px",display:"flex",justifyContent:"space-between",padding:"12px 14px",marginBottom:18}}><span style={{color:"#fff",fontSize:13,fontWeight:700}}>{t("os.orc.doc.total_label")}</span><span style={{color:"#fbbf24",fontSize:18,fontWeight:900}}>R$ {modalOrcamento.itens.reduce((a,i)=>a+(Number(i.preco)||0),0).toFixed(2)}</span></div><div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr",marginBottom:18}}><div style={{background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:8,padding:12}}><div style={{color:"#16a34a",fontSize:11,fontWeight:700,marginBottom:3}}>{t("os.orc.doc.garantia_label")}</div><div style={{color:"#374151",fontSize:12}}>{t("os.orc.doc.garantia_valor")}</div></div><div style={{background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:8,padding:12}}><div style={{color:"#ea580c",fontSize:11,fontWeight:700,marginBottom:3}}>{t("os.orc.doc.prazo_label")}</div><div style={{color:"#374151",fontSize:12}}>{t("os.orc.doc.prazo_valor")}</div></div></div>{fotasPremium.length > 0 && (<div style={{marginBottom:20}}><div style={{color:"#64748b",fontSize:11,fontWeight:700,letterSpacing:"0.08em",marginBottom:10,textTransform:"uppercase"}}>{t("os.orc.doc.registro_fotografico")}</div><div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(3,1fr)"}}>{fotasPremium.map((foto,i)=>(<div key={i} style={{borderRadius:8,overflow:"hidden",border:"1px solid #e2e8f0"}}><img src={foto.url||foto} alt={t("os.orc.doc.foto_alt")+" "+(i+1)} style={{height:110,objectFit:"cover",width:"100%"}} />{(foto.descricao)&&<div style={{background:"#f8fafc",color:"#374151",fontSize:11,fontWeight:600,padding:"4px 8px",textAlign:"center",borderTop:"1px solid #e2e8f0"}}>{foto.descricao}</div>}</div>))}</div></div>)}<div style={{borderTop:"2px solid #e2e8f0",display:"grid",gap:32,gridTemplateColumns:"1fr 1fr",paddingTop:20}}><div style={{textAlign:"center"}}><div style={{borderTop:"2px solid "+corSegura(),color:"#64748b",fontSize:12,paddingTop:8}}>{t("os.orc.doc.assinatura_responsavel")}</div></div><div style={{textAlign:"center"}}><div style={{borderTop:"2px solid "+corSegura(),color:"#64748b",fontSize:12,paddingTop:8}}>{t("os.orc.doc.assinatura_cliente")}</div></div></div></div></div>)}
              {modeloOrc==="premium" && (<div><div style={{background:"linear-gradient(135deg,#0f172a,#1e293b)",padding:"28px 32px",color:"#fff"}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div>{orcCfg?.logoUrl&&<img src={orcCfg.logoUrl} alt="logo" style={{height:90,marginBottom:10,objectFit:"contain",display:"block",background:"none",border:"none",boxShadow:"none"}} />}<div style={{color:corNoEscuro(),fontSize:10,fontWeight:700,letterSpacing:"0.15em",marginBottom:4,textTransform:"uppercase"}}>{rotuloDocOS}</div><div style={{fontSize:24,fontWeight:900}}>{orcCfg?.nomeEmpresa||config.nome||"SAAS.GL"}</div>{orcCfg?.telefone&&<div style={{color:"#94a3b8",fontSize:12,marginTop:3}}>{t("os.orc.doc.tel_prefix")} {orcCfg.telefone}</div>}{orcCfg?.endereco&&<div style={{color:"#94a3b8",fontSize:12}}>{orcCfg.endereco}</div>}{orcCfg?.documento&&<div style={{color:"#94a3b8",fontSize:12}}>CNPJ/CPF: {orcCfg.documento}</div>}{orcCfg?.email&&<div style={{color:"#94a3b8",fontSize:12}}>{orcCfg.email}</div>}</div><div style={{textAlign:"right"}}><div style={{color:"#94a3b8",fontSize:11}}>{t("os.orc.doc.ref_prefix")} {modalOrcamento.os.id}</div><div style={{color:"#94a3b8",fontSize:11}}>{fmtDataHoraOrc(modalOrcamento.dataHora)}</div></div></div></div><div style={{padding:28,background:"rgba(255,255,255,0.92)"}}><div style={{borderLeft:"4px solid "+corSegura(),background:corAlfa(0.06),borderRadius:"0 8px 8px 0",fontSize:12,lineHeight:1.8,marginBottom:20,padding:"12px 16px",color:"#374151"}}><div style={{fontWeight:800,marginBottom:3,color:corSegura()}}>{t("os.orc.doc.inspecao_tecnica")}</div>{modalOrcamento.os.relatoCliente||t("os.orc.doc.inspecao_default")}</div><div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(4,1fr)",marginBottom:20}}>{[{t:t("os.orc.doc.proprietario"),v:modalOrcamento.os.cliente,s:modalOrcamento.os.telefone||""},{t:tSeg("os.orc.doc.veiculo"),v:modalOrcamento.os.veiculo,s:modalOrcamento.os.placa},{t:t("os.orc.doc.km"),v:modalOrcamento.os.km||"—",s:""},{t:t("os.col_tecnico"),v:modalOrcamento.os.tecnico||"—",s:""}].map((f,i)=>(<div key={i} style={{background:"#0f172a",borderRadius:10,padding:14}}><div style={{color:corNoEscuro(),fontSize:10,fontWeight:700,marginBottom:3,textTransform:"uppercase"}}>{f.t}</div><div style={{fontSize:13,fontWeight:700,color:"#fff"}}>{f.v}</div>{f.s&&<div style={{color:"#94a3b8",fontSize:11,marginTop:2}}>{f.s}</div>}</div>))}</div><div style={{background:"#0f172a",borderRadius:"8px 8px 0 0",color:corNoEscuro(),display:"grid",fontSize:11,fontWeight:700,gridTemplateColumns:"1fr auto auto auto",padding:"10px 16px",textTransform:"uppercase"}}><span>{t("os.orc.doc.col_descricao")}</span><span style={{textAlign:"center",minWidth:50}}>{t("os.orc.doc.col_qtd")}</span><span style={{textAlign:"right",minWidth:90}}>{t("os.orc.doc.col_unit")}</span><span style={{textAlign:"right",minWidth:90}}>{t("os.orc.doc.col_total")}</span></div>{modalOrcamento.itens.map((item,i)=>(<div key={i} style={{background:i%2===0?"#f8fafc":"#fff",borderLeft:"1px solid #e2e8f0",borderRight:"1px solid #e2e8f0",borderBottom:"1px solid #e2e8f0",display:"grid",fontSize:13,gridTemplateColumns:"1fr auto auto auto",padding:"11px 16px",alignItems:"center"}}><span style={{fontWeight:600}}>{item.nome}</span><span style={{textAlign:"center",minWidth:50,color:"#64748b"}}>{item.qtd||1}</span><span style={{textAlign:"right",minWidth:90,color:"#64748b"}}>R$ {(Number(item.preco)/(item.qtd||1)).toFixed(2)}</span><span style={{textAlign:"right",minWidth:90,fontWeight:800}}>R$ {Number(item.preco).toFixed(2)}</span></div>))}<div style={{background:"linear-gradient(135deg,#0f172a,#1e293b)",borderRadius:"0 0 8px 8px",display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 16px",marginBottom:20}}><div><div style={{color:"#94a3b8",fontSize:11}}>{t("os.orc.doc.investimento_total")}</div><div style={{color:corNoEscuro(),fontSize:22,fontWeight:900}}>R$ {modalOrcamento.itens.reduce((a,i)=>a+(Number(i.preco)||0),0).toFixed(2)}</div></div><div style={{textAlign:"right"}}><div style={{color:"#94a3b8",fontSize:11}}>{t("os.orc.doc.validade_7")}</div><div style={{color:"#4ade80",fontSize:12,fontWeight:600}}>{t("os.orc.doc.garantia_90")}</div></div></div>{fotasPremium.length > 0 && (<div style={{marginBottom:20}}><div style={{color:corSegura(),fontSize:11,fontWeight:700,letterSpacing:"0.08em",marginBottom:10,textTransform:"uppercase"}}>{t("os.orc.doc.registro_fotografico")}</div><div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(3,1fr)"}}>{fotasPremium.map((foto,i)=>(<div key={i} style={{borderRadius:8,overflow:"hidden",border:"2px solid "+corSegura()}}><img src={foto.url||foto} alt={t("os.orc.doc.foto_alt")+" "+(i+1)} style={{height:110,objectFit:"cover",width:"100%"}} />{(foto.descricao)&&<div style={{background:"#0f172a",color:corNoEscuro(),fontSize:11,fontWeight:600,padding:"4px 8px",textAlign:"center"}}>{foto.descricao}</div>}</div>))}</div></div>)}<div style={{borderTop:"3px solid #0f172a",display:"grid",gap:32,gridTemplateColumns:"1fr 1fr",paddingTop:24}}><div style={{textAlign:"center"}}><div style={{borderTop:"2px solid "+corSegura(),color:"#64748b",fontSize:12,paddingTop:8}}>{t("os.orc.doc.assinatura_responsavel")}</div></div><div style={{textAlign:"center"}}><div style={{borderTop:"2px solid "+corSegura(),color:"#64748b",fontSize:12,paddingTop:8}}>{t("os.orc.doc.assinatura_cliente")}</div></div></div></div></div>)}
              </div>

            </>
          )}
        </Modal>
      )}

      {modalStatus && (
        <Modal onClose={()=>setModalStatus(null)} largura={520}>
          <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
            <div>
              <div style={{color:"var(--accent2)",fontFamily:"monospace",fontSize:12,marginBottom:4}}>{modalStatus.id}</div>
              <div style={{fontSize:18,fontWeight:800}}>{t("os.status_modal.titulo")}</div>
              <div style={{color:"var(--text2)",fontSize:13,marginTop:4}}>{modalStatus.cliente} - {modalStatus.veiculo}</div>
            </div>
            <BtnFechar onClick={()=>setModalStatus(null)} />
          </div>
          <div style={{marginBottom:16}}>
            <div style={{color:"var(--text3)",fontSize:11,fontWeight:700,letterSpacing:"0.06em",marginBottom:12,textTransform:"uppercase"}}>{t("os.status_modal.atual")}</div>
            <div style={{alignItems:"center",display:"inline-flex",gap:8,background:STATUS_COR[modalStatus.status]?.bg||"var(--bg3)",border:"2px solid "+(STATUS_COR[modalStatus.status]?.dot||"var(--border)"),borderRadius:20,padding:"6px 16px"}}>
              <div style={{background:STATUS_COR[modalStatus.status]?.dot,borderRadius:99,height:8,width:8}} />
              <span style={{color:STATUS_COR[modalStatus.status]?.cor,fontSize:13,fontWeight:700}}>{STATUS_LABEL(modalStatus.status)}</span>
            </div>
          </div>
          <div style={{color:"var(--text3)",fontSize:11,fontWeight:700,letterSpacing:"0.06em",marginBottom:12,textTransform:"uppercase"}}>{t("os.status_modal.selecione")}</div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {STATUS_FLOW.filter(s => s !== modalStatus.status).map(s => {
              const cor = STATUS_COR[s];
              return (
                <button key={s} onClick={()=>moverStatus(modalStatus.id, s)}
                  style={{alignItems:"center",background:cor.bg,border:"2px solid "+cor.dot,borderRadius:10,cursor:"pointer",display:"flex",gap:12,padding:"12px 16px",textAlign:"left",width:"100%"}}
                  onMouseOver={e=>e.currentTarget.style.opacity="0.8"}
                  onMouseOut={e=>e.currentTarget.style.opacity="1"}>
                  <div style={{background:cor.dot,borderRadius:99,flexShrink:0,height:10,width:10}} />
                  <div style={{color:cor.cor,fontSize:14,fontWeight:700}}>{STATUS_LABEL(s)}</div>
                </button>
              );
            })}
          </div>
        </Modal>
      )}

      {modalLixeira && (
        <Modal onClose={()=>setModalLixeira(false)} largura={800}>
          <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
            <div>
              <div style={{color:"#ef4444",fontSize:12,fontWeight:700,marginBottom:4}}>{t("os.lixeira_modal.label")}</div>
              <div style={{fontSize:18,fontWeight:800}}>{t("os.lixeira_modal.titulo",{count:lixeira.length})}</div>
            </div>
            <div style={{display:"flex",gap:8}}>
              {lixeira.length > 0 && (
                <button onClick={()=>{if(!window.confirm(t("os.lixeira_modal.confirm_esvaziar"))) return; salvarLixeira([]); setLixeira([]); setModalLixeira(false);}} style={{background:"#ef444422",border:"1px solid #ef4444",borderRadius:8,color:"#ef4444",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 16px"}}>
                  {t("os.lixeira_modal.esvaziar")}
                </button>
              )}
              <BtnFechar onClick={()=>setModalLixeira(false)} />
            </div>
          </div>
          {erroRestaurar && (
            <div style={{background:"#ef444415",border:"1px solid #ef4444",borderRadius:8,color:"var(--text)",
                         fontSize:12.5,lineHeight:1.6,marginBottom:14,padding:"11px 14px"}}>
              <b style={{color:"#ef4444"}}>{t("os.lixeira_modal.nao_restaurou","Nao restaurou")}: </b>
              {erroRestaurar}
            </div>
          )}
          {lixeira.length === 0 ? (
            <div style={{color:"var(--text3)",fontSize:14,padding:"40px 0",textAlign:"center"}}>{t("os.lixeira_modal.vazia")}</div>
          ) : (
            <div style={{...rolo(500),display:"flex",flexDirection:"column",gap:8}}>
              {lixeira.map(os => (
                <div key={os.id} style={{alignItems:"center",background:"var(--bg3)",border:"1px solid #ef444422",borderRadius:10,display:"flex",gap:12,justifyContent:"space-between",padding:"12px 16px"}}>
                  <div style={{display:"flex",gap:16,flex:1}}>
                    <div>
                      <div style={{color:"#ef4444",fontFamily:"monospace",fontSize:11,fontWeight:700}}>{os.id}</div>
                      <div style={{fontSize:13,fontWeight:600,marginTop:2}}>{os.cliente}</div>
                      <div style={{color:"var(--text3)",fontSize:11}}>{os.veiculo} - {os.placa}</div>
                    </div>
                    <div>
                      <div style={{color:"var(--text3)",fontSize:11}}>{t("os.lixeira_modal.removido_em")}</div>
                      <div style={{fontSize:12}}>{os._removidoEm ? new Date(os._removidoEm).toLocaleString("pt-BR") : "-"}</div>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={()=>restaurarOS(os)} disabled={!!restaurando} style={{background:"#22c55e22",border:"1px solid #22c55e",borderRadius:6,color:"#22c55e",cursor:restaurando?"default":"pointer",fontSize:11,opacity:restaurando?0.5:1,padding:"5px 10px"}}>{restaurando===os.id?t("os.lixeira_modal.restaurando","Restaurando..."):t("os.lixeira_modal.restaurar")}</button>
                    <button onClick={()=>{ if(!window.confirm(t("os.lixeira_modal.confirm_excluir"))) return; const novaLix=lixeira.filter(o=>o.id!==os.id); salvarLixeira(novaLix); setLixeira(novaLix); }} style={{background:"#ef444422",border:"1px solid #ef4444",borderRadius:6,color:"#ef4444",cursor:"pointer",fontSize:11,padding:"5px 10px"}}>{t("os.lixeira_modal.excluir")}</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </Modal>
      )}

      {modalImpressao && (
        <Modal onClose={()=>setModalImpressao(false)} largura={420}>
          <div style={{textAlign:"center",padding:"10px 0 20px"}}>
            <div style={{fontSize:18,fontWeight:800,marginBottom:8}}>{t("os.impressao.titulo")}</div>
            <div style={{color:"var(--text2)",fontSize:13,marginBottom:28}}>{t("os.impressao.subtitulo")}</div>
            <div style={{display:"flex",gap:12,justifyContent:"center"}}>
              <button onClick={()=>imprimirDoc(false)} style={{alignItems:"center",background:"linear-gradient(135deg,#3b82f6,#1e40af)",border:"none",borderRadius:12,color:"#fff",cursor:"pointer",display:"flex",flexDirection:"column",gap:8,padding:"20px 28px"}}>
                <span style={{fontSize:14,fontWeight:700}}>{t("os.impressao.colorido")}</span>
                <span style={{fontSize:11,opacity:0.8}}>{t("os.impressao.colorido_desc")}</span>
              </button>
              <button onClick={()=>imprimirDoc(true)} style={{alignItems:"center",background:"linear-gradient(135deg,#64748b,#1e293b)",border:"none",borderRadius:12,color:"#fff",cursor:"pointer",display:"flex",flexDirection:"column",gap:8,padding:"20px 28px"}}>
                <span style={{fontSize:14,fontWeight:700}}>{t("os.impressao.pb")}</span>
                <span style={{fontSize:11,opacity:0.8}}>{t("os.impressao.pb_desc")}</span>
              </button>
            </div>
            <button onClick={()=>setModalImpressao(false)} style={{background:"transparent",border:"none",color:"var(--text3)",cursor:"pointer",fontSize:12,marginTop:20}}>{t("os.impressao.cancelar")}</button>
          </div>
        </Modal>
      )}

      {modalConcluir && (
        <Modal onClose={()=>setModalConcluir(null)} largura={400}>
          <div style={{textAlign:"center",padding:"10px 0"}}>
            <div style={{fontSize:32,marginBottom:12}}>✅</div>
            <div style={{fontSize:18,fontWeight:800,marginBottom:8}}>{t("os.concluir.titulo")}</div>
            <div style={{color:"var(--text2)",fontSize:14,marginBottom:24}}>{modalConcluir.id} - {modalConcluir.cliente}</div>
            <div style={{display:"flex",gap:10,justifyContent:"center"}}>
              <button onClick={()=>setModalConcluir(null)} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:13,padding:"10px 20px"}}>{t("os.concluir.cancelar")}</button>
              <button onClick={confirmarConclusao} style={{background:"#22c55e",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,padding:"10px 24px"}}>{t("os.concluir.confirmar")}</button>
            </div>
          </div>
        </Modal>
      )}
      {modalPagamento && (
        <Modal onClose={fecharPagamentos} largura={520}>
          <div style={{alignItems:"flex-start",display:"flex",justifyContent:"space-between",marginBottom:4}}>
            <div style={{fontSize:18,fontWeight:800}}>{"\uD83D\uDCB3"} Pagamentos</div>
            <BtnFechar onClick={fecharPagamentos} />
          </div>
          <div style={{color:"var(--text2)",fontSize:13,marginBottom:16}}>{modalPagamento.id} - {modalPagamento.cliente}</div>
          <style>{`
            @keyframes ringPulseQuitado { 0%{opacity:.9;transform:scale(.94);} 100%{opacity:0;transform:scale(1.28);} }
            @keyframes glowBreathVerde { 0%{box-shadow:0 0 0 rgba(34,197,94,0);} 30%{box-shadow:0 0 24px rgba(34,197,94,.55);} 100%{box-shadow:0 0 0 rgba(34,197,94,0);} }
            .ring-wrap-quitado{ position:relative; display:inline-flex; }
            .ring-wrap-quitado::before{ content:""; position:absolute; inset:-8px; border-radius:24px; border:2px solid #22c55e; opacity:0; }
            .ring-wrap-quitado.play::before{ animation: ringPulseQuitado 900ms ease-out 2; }
            .glow-breath-el.play{ animation: glowBreathVerde 1600ms ease-in-out 1; }
            @media (prefers-reduced-motion: reduce){ .ring-wrap-quitado.play::before, .glow-breath-el.play{ animation:none!important; } }
          `}</style>
          {carregandoPagamentos ? (
            <div style={{fontSize:13,color:"var(--text3)"}}>Carregando...</div>
          ) : pagamentosData ? (
            <>
              {/* Situacao financeira desta O.S.
                  A barra e o resumo: verde e dinheiro que entrou de verdade
                  (os_pagamentos confirmados), ambar e promissoria prometida
                  mas ainda nao recebida, e o trilho vazio e o que nao tem
                  cobertura nenhuma. Separar as duas primeiras e o ponto
                  inteiro deste modulo -- promessa nao e caixa.
                  "Vencido" so aparece quando existe, porque e a unica
                  informacao desta tela que pede acao hoje. */}
              <div key={"stats-"+pagamentosData.total_pago} className={"glow-breath-el"+(glowSucesso?" play":"")} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,marginBottom:16,padding:"14px 16px"}}>
                <div style={{alignItems:"center",display:"flex",flexWrap:"wrap",gap:10,justifyContent:"space-between"}}>
                  <div>
                    <div style={{color:"var(--text3)",fontSize:10,fontWeight:700,letterSpacing:"0.09em",textTransform:"uppercase"}}>Total da O.S.</div>
                    <div style={{fontSize:23,fontWeight:800,letterSpacing:"-0.02em",lineHeight:1.15}}>R$ {pagamentosData.total_os.toFixed(2)}</div>
                  </div>
                  <span key={"badge-"+pagamentosData.total_pago} className={"ring-wrap-quitado"+(pagamentosData.status_financeiro==="quitado"?" play":"")}>
                    <span style={{background:STATUS_FIN_COR[pagamentosData.status_financeiro]||"var(--bg3)",borderRadius:20,fontSize:11,fontWeight:700,letterSpacing:"0.03em",padding:"5px 14px"}}>{STATUS_FIN_LABEL[pagamentosData.status_financeiro]||pagamentosData.status_financeiro}</span>
                  </span>
                </div>

                <div style={{background:"var(--bg2)",borderRadius:99,display:"flex",height:7,marginTop:13,overflow:"hidden"}}>
                  <div style={{background:"#22c55e",transition:"width .45s ease",width:(pagamentosData.total_os>0?Math.min(100,(pagamentosData.total_pago/pagamentosData.total_os)*100):0)+"%"}} />
                  <div style={{background:resumoAcordo().vencido>0.009?"#ef4444":"#f59e0b",transition:"width .45s ease",width:(pagamentosData.total_os>0?Math.min(100,(resumoAcordo().aReceber/pagamentosData.total_os)*100):0)+"%"}} />
                </div>

                <div style={{display:"flex",flexWrap:"wrap",gap:"8px 20px",marginTop:12}}>
                  <span style={{alignItems:"center",display:"flex",gap:7}}>
                    <span style={{background:"#22c55e",borderRadius:99,flex:"none",height:8,width:8}} />
                    <span style={{color:"var(--text3)",fontSize:11.5}}>Recebido</span>
                    <b style={{color:"#22c55e",fontSize:13.5}}>R$ {pagamentosData.total_pago.toFixed(2)}</b>
                  </span>
                  {resumoAcordo().aReceber>0.009 && (
                    <span style={{alignItems:"center",display:"flex",gap:7}}>
                      <span style={{background:"#f59e0b",borderRadius:99,flex:"none",height:8,width:8}} />
                      <span style={{color:"var(--text3)",fontSize:11.5}}>A receber</span>
                      <b style={{color:"#f59e0b",fontSize:13.5}}>R$ {resumoAcordo().aReceber.toFixed(2)}</b>
                    </span>
                  )}
                  <span style={{alignItems:"center",display:"flex",gap:7}}>
                    <span style={{background:pagamentosData.saldo>0.009?"var(--text3)":"#22c55e",borderRadius:99,flex:"none",height:8,width:8}} />
                    <span style={{color:"var(--text3)",fontSize:11.5}}>Saldo em aberto</span>
                    <b style={{color:pagamentosData.saldo>0.009?"var(--text)":"#22c55e",fontSize:13.5}}>R$ {pagamentosData.saldo.toFixed(2)}</b>
                  </span>
                </div>

                {resumoAcordo().vencido>0.009 && (
                  <div style={{alignItems:"center",background:"#ef444418",border:"1px solid #ef444455",borderRadius:8,display:"flex",gap:9,marginTop:12,padding:"9px 12px"}}>
                    <span style={{background:"#ef4444",borderRadius:99,flex:"none",height:8,width:8}} />
                    <span style={{color:"var(--text)",fontSize:12.5}}>
                      <b style={{color:"#ef4444"}}>R$ {resumoAcordo().vencido.toFixed(2)}</b> em parcelas vencidas
                    </span>
                  </div>
                )}
              </div>
              {pagamentosData.saldo>0.009 && (
                <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:12,marginBottom:16}}>
                  <div style={{color:"var(--text3)",fontSize:11,marginBottom:8,fontWeight:700}}>Registrar novo pagamento</div>
                  <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                    <input type="number" step="0.01" min="0" placeholder="Valor" value={formPagamento.valor} onChange={e=>setFormPagamento(f=>({...f,valor:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,padding:"6px 10px",width:110}} />
                    <select value={formPagamento.forma} onChange={e=>setFormPagamento(f=>({...f,forma:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,padding:"6px 10px"}}>
                      <option value="pix">Pix</option>
                      <option value="dinheiro">Dinheiro</option>
                      <option value="credito">Cartao de credito</option>
                      <option value="debito">Cartao de debito</option>
                      <option value="transferencia">Transferencia</option>
                      <option value="outros">Outros</option>
                    </select>
                    <input placeholder="Observacao (opcional)" value={formPagamento.observacao} onChange={e=>setFormPagamento(f=>({...f,observacao:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,padding:"6px 10px",flex:1,minWidth:140}} />
                    <button onClick={registrarNovoPagamento} disabled={enviandoPagamento} style={{background:"#22c55e",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 16px",opacity:enviandoPagamento?0.7:1}}>{enviandoPagamento?"Enviando...":"Registrar"}</button>
                  </div>
                  {erroPagamento && <div style={{color:"#ef4444",fontSize:12,marginTop:8}}>{erroPagamento}</div>}
                </div>
              )}
              {/* PROMISSORIA / ACORDO A PRAZO
                  Fica separado do pagamento direto de proposito: o que se
                  registra aqui e uma DIVIDA com vencimento, nao um
                  recebimento. Enquanto a parcela nao recebe baixa, ela nao
                  entra no caixa em lugar nenhum do sistema. */}
              {acordoData && acordoData.acordo && acordoData.acordo.status==="ativo" ? (
                <div style={{background:"var(--bg3)",border:"1px solid #f59e0b55",borderRadius:8,padding:12,marginBottom:16}}>
                  <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:8,marginBottom:10}}>
                    <div>
                      <div style={{alignItems:"center",display:"flex",gap:8}}>
                        <span style={{background:"#f59e0b",borderRadius:99,flex:"none",height:7,width:7}} />
                        <span style={{color:"#f59e0b",fontSize:10.5,fontWeight:700,letterSpacing:"0.09em",textTransform:"uppercase"}}>Promissoria</span>
                      </div>
                      <div style={{color:"var(--text2)",fontSize:12.5,marginTop:3}}>
                        {acordoData.acordo.numero_parcelas} parcela{acordoData.acordo.numero_parcelas>1?"s":""} &middot; total <b style={{color:"var(--text)"}}>R$ {Number(acordoData.acordo.valor_total_acordado).toFixed(2)}</b>
                        {(acordoData.parcelas||[]).filter(p=>p.situacao==="paga").length>0 && (
                          <> &middot; {(acordoData.parcelas||[]).filter(p=>p.situacao==="paga").length} recebida{(acordoData.parcelas||[]).filter(p=>p.situacao==="paga").length>1?"s":""}</>
                        )}
                      </div>
                    </div>
                    {!cancelandoAcordo && (
                      <button onClick={()=>{setCancelandoAcordo(true);setMotivoCancelAcordo("");setErroAcordo("");}} style={{background:"transparent",border:"1px solid #ef4444",borderRadius:6,color:"#ef4444",cursor:"pointer",fontSize:11,padding:"4px 10px"}}>Cancelar acordo</button>
                    )}
                  </div>
                  {cancelandoAcordo && (
                    <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10}}>
                      <input placeholder="Motivo do cancelamento" value={motivoCancelAcordo} onChange={e=>setMotivoCancelAcordo(e.target.value)} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:12,padding:"5px 9px",flex:1,minWidth:160}} />
                      <button onClick={()=>cancelarAcordo(acordoData.acordo.id)} disabled={enviandoAcordo} style={{background:"#ef4444",border:"none",borderRadius:6,color:"#fff",cursor:"pointer",fontSize:11,padding:"5px 12px"}}>Confirmar</button>
                      <button onClick={()=>{setCancelandoAcordo(false);setMotivoCancelAcordo("");}} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:6,color:"var(--text2)",cursor:"pointer",fontSize:11,padding:"5px 12px"}}>Voltar</button>
                    </div>
                  )}
                  {(acordoData.parcelas||[]).map(p=>{
                    const hoje = new Date().toISOString().slice(0,10);
                    const venc = String(p.data_vencimento||"").slice(0,10);
                    const atrasada = p.situacao==="pendente" && venc < hoje;
                    const cor = p.situacao==="paga" ? "#22c55e" : atrasada ? "#ef4444" : "#f59e0b";
                    const rotulo = p.situacao==="paga" ? "Recebida" : p.situacao==="cancelada" ? "Cancelada" : atrasada ? "Vencida" : "A receber";
                    return (
                      <div key={p.id} style={{alignItems:"center",borderTop:"1px solid var(--border)",display:"flex",flexWrap:"wrap",gap:8,justifyContent:"space-between",padding:"8px 0",rowGap:6}}>
                        <div>
                          <span style={{color:"var(--text3)",fontSize:11,marginRight:8}}>{p.numero_parcela}/{acordoData.acordo.numero_parcelas}</span>
                          <span style={{fontWeight:700}}>R$ {Number(p.valor).toFixed(2)}</span>
                          <span style={{color:"var(--text3)",fontSize:12,marginLeft:8}}>venc. {venc.split("-").reverse().join("/")}</span>
                          <span style={{color:cor,fontSize:11,fontWeight:700,marginLeft:8}}>{rotulo}</span>
                        </div>
                        {p.situacao==="pendente" && (
                          pagandoParcelaId===p.id ? (
                            <div style={{display:"flex",gap:6}}>
                              <select value={formaPagParcela} onChange={e=>setFormaPagParcela(e.target.value)} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:12,padding:"4px 8px"}}>
                                <option value="pix">Pix</option>
                                <option value="dinheiro">Dinheiro</option>
                                <option value="credito">Cartao de credito</option>
                                <option value="debito">Cartao de debito</option>
                                <option value="transferencia">Transferencia</option>
                                <option value="outros">Outros</option>
                              </select>
                              <button onClick={()=>receberParcela(p.id)} disabled={enviandoAcordo} style={{background:"#22c55e",border:"none",borderRadius:6,color:"#fff",cursor:"pointer",fontSize:11,fontWeight:700,padding:"5px 10px"}}>{enviandoAcordo?"...":"Confirmar"}</button>
                              <button onClick={()=>setPagandoParcelaId(null)} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:6,color:"var(--text2)",cursor:"pointer",fontSize:11,padding:"5px 10px"}}>Voltar</button>
                            </div>
                          ) : (
                            <button onClick={()=>{setPagandoParcelaId(p.id);setFormaPagParcela("pix");setErroAcordo("");}} style={{background:"transparent",border:"1px solid #22c55e",borderRadius:6,color:"#22c55e",cursor:"pointer",fontSize:11,padding:"5px 10px"}}>Marcar como recebido</button>
                          )
                        )}
                        {p.situacao==="paga" && p.data_pagamento && (
                          <span style={{color:"var(--text3)",fontSize:11}}>{new Date(p.data_pagamento).toLocaleDateString("pt-BR")} &middot; {p.forma_pagamento||"-"}</span>
                        )}
                      </div>
                    );
                  })}
                  {erroAcordo && <div style={{color:"#ef4444",fontSize:12,marginTop:8}}>{erroAcordo}</div>}
                </div>
              ) : pagamentosData.saldo>0.009 && !carregandoAcordo ? (
                <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:12,marginBottom:16}}>
                  {!modalAcordo ? (
                    <button onClick={()=>{setModalAcordo("novo");setErroAcordo("");setParcelasAcordo([]);setFormAcordoAuto(f=>({...f,valorTotal:pagamentosData.saldo.toFixed(2)}));}} style={{background:"transparent",border:"1px dashed #f59e0b",borderRadius:8,color:"#f59e0b",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px",width:"100%"}}>
                      Registrar promissoria (a prazo)
                    </button>
                  ) : (
                    <>
                      <div style={{color:"var(--text3)",fontSize:11,marginBottom:8,fontWeight:700}}>Promissoria &mdash; o valor so entra no caixa quando a parcela for recebida</div>
                      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:8}}>
                        <input type="number" step="0.01" min="0" placeholder="Valor" value={formAcordoAuto.valorTotal} onChange={e=>setFormAcordoAuto(f=>({...f,valorTotal:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,padding:"6px 10px",width:110}} />
                        <input type="number" min="1" max="60" placeholder="Parcelas" value={formAcordoAuto.numeroParcelas} onChange={e=>setFormAcordoAuto(f=>({...f,numeroParcelas:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,padding:"6px 10px",width:90}} />
                        <select value={formAcordoAuto.intervaloTipo} onChange={e=>setFormAcordoAuto(f=>({...f,intervaloTipo:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,padding:"6px 10px"}}>
                          <option value="mensal">Mensal</option>
                          <option value="quinzenal">Quinzenal</option>
                          <option value="semanal">Semanal</option>
                          <option value="personalizado">A cada N dias</option>
                        </select>
                        {formAcordoAuto.intervaloTipo==="personalizado" && (
                          <input type="number" min="1" placeholder="Dias" value={formAcordoAuto.intervaloDias} onChange={e=>setFormAcordoAuto(f=>({...f,intervaloDias:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,padding:"6px 10px",width:80}} />
                        )}
                        <input type="date" value={formAcordoAuto.dataInicio} onChange={e=>setFormAcordoAuto(f=>({...f,dataInicio:e.target.value}))} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:13,padding:"6px 10px"}} />
                        <button onClick={gerarPreviaAcordo} disabled={enviandoAcordo} style={{background:"#f59e0b",border:"none",borderRadius:8,color:"#111",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px"}}>{enviandoAcordo?"...":"Calcular parcelas"}</button>
                        <button onClick={()=>{setModalAcordo(null);setParcelasAcordo([]);setErroAcordo("");}} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>Cancelar</button>
                      </div>
                      {parcelasAcordo.length>0 && (
                        <div style={{borderTop:"1px solid var(--border)",marginTop:8,paddingTop:8}}>
                          <div style={{color:"var(--text3)",fontSize:11,marginBottom:6}}>Previa &mdash; nada foi gravado ainda</div>
                          {parcelasAcordo.map(p=>(
                            <div key={p.numero_parcela} style={{color:"var(--text2)",display:"flex",fontSize:12.5,gap:12,padding:"3px 0"}}>
                              <span style={{color:"var(--text3)",width:30}}>{p.numero_parcela}x</span>
                              <span style={{fontWeight:600,width:90}}>R$ {Number(p.valor).toFixed(2)}</span>
                              <span>{String(p.data_vencimento).split("-").reverse().join("/")}</span>
                            </div>
                          ))}
                          <button onClick={confirmarAcordo} disabled={enviandoAcordo} style={{background:"#22c55e",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,marginTop:10,padding:"8px 16px"}}>{enviandoAcordo?"Registrando...":"Confirmar promissoria"}</button>
                        </div>
                      )}
                      {erroAcordo && <div style={{color:"#ef4444",fontSize:12,marginTop:8}}>{erroAcordo}</div>}
                    </>
                  )}
                </div>
              ) : null}
              <div style={{color:"var(--text3)",fontSize:11,marginBottom:8,fontWeight:700}}>Historico</div>
              {pagamentosData.pagamentos.length===0 ? (
                <div style={{fontSize:13,color:"var(--text3)"}}>Nenhum pagamento registrado ainda.</div>
              ) : pagamentosData.pagamentos.map(p=>(
                <div key={p.id} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,padding:10,marginBottom:8}}>
                  <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",flexWrap:"wrap",rowGap:6}}>
                    <div>
                      <span style={{fontWeight:700}}>R$ {Number(p.valor).toFixed(2)}</span>
                      <span style={{color:"var(--text3)",fontSize:12,marginLeft:8}}>{p.forma_pagamento||"-"}</span>
                      <span style={{color:"var(--text3)",fontSize:11,marginLeft:8}}>{new Date(p.criado_em).toLocaleString("pt-BR")}</span>
                    </div>
                    {p.status==="confirmado" ? (
                      estornandoId===p.id ? (
                        <div style={{display:"flex",gap:6}}>
                          <input placeholder="Motivo do estorno" value={motivoEstorno} onChange={e=>setMotivoEstorno(e.target.value)} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text)",fontSize:12,padding:"4px 8px",width:140}} />
                          <button onClick={()=>confirmarEstorno(p.id)} style={{background:"#ef4444",border:"none",borderRadius:6,color:"#fff",cursor:"pointer",fontSize:11,padding:"5px 10px"}}>Confirmar</button>
                          <button onClick={()=>{setEstornandoId(null);setMotivoEstorno("");}} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:6,color:"var(--text2)",cursor:"pointer",fontSize:11,padding:"5px 10px"}}>Cancelar</button>
                        </div>
                      ) : (
                        <button onClick={()=>{setEstornandoId(p.id);setMotivoEstorno("");setErroPagamento("");}} style={{background:"transparent",border:"1px solid #ef4444",borderRadius:6,color:"#ef4444",cursor:"pointer",fontSize:11,padding:"5px 10px"}}>Estornar</button>
                      )
                    ) : (
                      <span style={{color:"#ef4444",fontSize:11,fontWeight:700}}>Estornado</span>
                    )}
                  </div>
                  {p.observacao && <div style={{color:"var(--text3)",fontSize:12,marginTop:4}}>{p.observacao}</div>}
                  {p.status==="estornado" && p.motivo_estorno && <div style={{color:"#ef4444",fontSize:11,marginTop:4}}>Motivo: {p.motivo_estorno}</div>}
                </div>
              ))}
            </>
          ) : (
            <div style={{fontSize:13,color:"#ef4444"}}>{erroPagamento||"Nao foi possivel carregar os pagamentos."}</div>
          )}
        </Modal>
      )}

    </Layout>
  );
}

